import { useContext, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useForm, Controller, useWatch } from "react-hook-form";
import _ from "lodash";
import PropTypes from "prop-types";
import { AuthenticationContext } from "@cloudmlm/cloudmlm-auth";
import {
  Box,
  Button,
  Card,
  Grid,
  Stack,
  Typography,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Checkbox,
  DialogTitle,
  DialogContent,
  DialogActions,
  Dialog,
  IconButton,
} from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CloseIcon from "@mui/icons-material/Close";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import CustomTextField from "../../shared-components/form-controls/customTextField";
import CustomAutoCompleteDropdown from "../../shared-components/form-controls/customAutoCompleteDropdown";
import CustomTextAreaField from "../.././shared-components/form-controls/customTextAreaField";
import dataConstant from "../../constants/dataConstants";
import CustomMultiSelectDropdown from "../../shared-components/form-controls/customMultiSelectDropdown";
import {
  nameValidator,
  phoneNumberValidator,
  zipCodeValidator,
} from "../../shared-components/validator/fieldValidator";
import CommonSnackBar from "../../shared-components/snackbar/commonSnackbar";
import SnackState from "../../shared-components/snackbar/snackState";
import CustomMultipleImageUpload from "../../shared-components/customMultipleImageUpload";
import {
  DocumentUpload,
  httpGet,
  httpPost,
} from "../../services/commonService";
import urlConstant from "../../constants/urlConstants";
import { selectUserDetail } from "../../redux/slice/userSlice";

let leadID = "";
let stateList = [];
let leadData = [];
let roofAgeList = [];
let roofTypeList = [];
let kindOfElectricPanelList = [];
let mountingPreferenceList = [];
let financingList = [];
let workList = [];
let mentorList = [];
let leadStatusList = [];
let isFormFieldDisable = false;
let affiliateList = [];
let affiliateCommissionList = [];
let productInterestedList = [];
let isMentor = false;
let isMentorButtonDisable = false;
let isRejected = false;
let isApprovalPenidng = false;
let isApproved = false;
let searchableMentorList = [];
let languageList = [];
let homeSecurityTypeList = [];
let adtHomeSecurityProductInterestedList = [];
let brinksHomeSecurityProductInterestedList = [];
let internetMobilePhoneHomeSecurityProductList = [];
let userDetails;

const ManageProjects = () => {
  const { id } = useParams();
  userDetails = useSelector(selectUserDetail);
  const navigate = useNavigate();
  const authenticationState = useContext(AuthenticationContext);
  const location = useLocation();
  const { t } = useTranslation();
  const [businessType, setBusinessType] = useState(
    location.state?.businessType || ""
  );
  isMentor = location.state ? location.state.IsMentor : false;
  const formTitleAdd = `${t("LeadCollection.AddLead")}  - ${businessType}`;
  const formTitleEdit = `${t("LeadCollection.EditLead")}  - ${businessType}`;
  const [snack, closeSnack, showSnackbar] = SnackState();
  const [uploadedFile, setUploadedFile] = useState([]);
  const stateDefaultValue = [{ value: "", label: "Select state" }];
  const roofAgeDefaultValue = [{ value: null, label: "Select Roof Age" }];
  const roofTypeDefaultValue = [{ value: null, label: "Select Roof Type" }];
  const LeadStatusDefaultValue = [{ value: "New", label: "New" }];
  const commonDefaultValue = [{ value: null, label: "Type to search " }];
  const mentorDefaultValue = [{ value: null, label: "Select " }];
  const affiliateDefaultValue = [{ value: null, label: "Select " }];
  const affiliateCommissionDefaultValue = [{ value: null, label: "Select " }];
  const [activeStep, setActiveStep] = useState(0);
  const [shouldKeepMentorDropdownOpen, setShouldKeepMentorDropdownOpen] =
    useState(false);
  const [dropdownData, setDropdownData] = useState({
    states: [],
    searchableMentor: [],
    mentor: [],
    affiliate: [],
    affiliateCommission: [],
    roofAge: [],
    roofType: [],
    kindOfElectricPanel: [],
    mountingPreference: [],
    financing: [],
    work: [],
    leadStatus: [],
    affiliateCommissionList: [],
    languageList: [],
    financingList: [],
    productInterestedList: [],
    workList: [],
    kindOfElectricPanelList: [],
    affiliateCommissionList: [],
    leadStatusList: [],
    affiliateData: [],
    homeSecurityTypeList: [],
    adtHomeSecurityProductInterestedList: [],
    brinksHomeSecurityProductInterestedList: [],
    internetMobilePhoneHomeSecurityProductList: []
  });
  const [state, setState] = useState({
    isDisplay: false,
    isSubmitDisabled: false,
    isFinalSubmitDisabled: false,
    finalSubmitCount: 0,
    submitCount: 0,
    submitToMentorCount: 0,
    isDeletedPopupOpen: false,
    selectedDeletedImage: "",
    isUploadFileDeletePopupOpen: false,
    uploadedDeleteImageId: "",
    isFinalSubmitPopupOpen: false,
    isMentorAcceptPopupOpen: false,
    isMentorRejectPopupOpen: false,
    isHomeSecurityPackagesPopupOpen: false,
    formTitle: "",
    projectList: [],
    isAddLeadPopupOpen: false,
    isMentorSearchableDropDownCalled: false,
    isAffiliateDropDownCalled: false,
    leadInfo: {
      acctID: "",
      mentorAcctID: "",
      firstName: "",
      lastName: "",
      fileName: "",
      state: "",
      isExistingSystem: false,
      assignYouselfMentor: false,
      mentor: mentorDefaultValue,
      submitToFreedomForever: false,
      leadStatus: LeadStatusDefaultValue,
      affiliateCommissionRein: null,
      affiliateCommissionSecurity: null,
      isCreditForm: false,
    },
    uploadBills: [],
  });

  const [mentorFlag, setMentorFlag] = useState(
    location.state ? location.state.IsMentor : false
  );
  const [selfMentorFlag, setSelfMentorFlag] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [showMentor, setShowMentor] = useState(false);
  const [description, setDescription] = useState("");
  const [descriptionOn, setDescriptionOn] = useState(false);
  const [languageIds, setsearchlanguages] = useState([]);
  const [stateIds, setsearchStates] = useState([]);
  const [isFinalSubmit, setIsFinalSubmit] = useState(false);
  const [selectedHomeSecurityType, setSelectedHomeSecurityType] = useState("");
  const [expandedSections, setExpandedSections] = useState({
    0: true,
    1: true,
    2: true,
    3: true,
    4: true,
    5: true,
  });
  const [autoOpenedSections, setAutoOpenedSections] = useState({});
  const sectionRefs = useRef([]);
  const sectionHeaderRefs = useRef([]);

  const scrollToFirstErrorSection = (errors) => {
    const sectionIndex = Object.keys(sectionFields).find((key) => {
      const fields = sectionFields[key] || [];
      return fields.some((field) => errors?.[field]);
    });

    if (sectionIndex !== undefined) {
      const idx = Number(sectionIndex);

      setExpandedSections((prev) => ({
        ...prev,
        [idx]: true,
      }));

      const scrollToElement = () => {
        const header = sectionHeaderRefs.current[idx];
        const section = sectionRefs.current[idx];
        const target = header || section;
        if (!target) return;

        target.scrollIntoView({ behavior: "smooth", block: "start" });
        const offset = 80;
        window.scrollBy({ top: -offset, left: 0, behavior: "smooth" });
      };
      requestAnimationFrame(() => requestAnimationFrame(scrollToElement));
    }
  };

  const toggleSection = (index) => {
    setExpandedSections((prev) => {
      const nextValue = prev[index] === undefined ? false : !prev[index];
      setAutoOpenedSections((prevAuto) => ({
        ...prevAuto,
        [index]: nextValue === false ? false : true,
      }));
      return {
        ...prev,
        [index]: nextValue,
      };
    });
  };

  const methods = useForm({
    mode: "all",
    defaultValues: {
      firstName: "",
      lastName: "",
      emailAddress: "",
      phoneNumber: "",
      streetAddress: "",
      menteeFirstName: "",
      menteeLastName: "",
      menteeEmail: "",
      menteePhoneNumber: "",
      city: "",
      state: "",
      zipCode: "",
      searchableMentor: "",
      StateIds: [],
      LanguageIds: [],
      mentor: [],
      description: "",
      affiliate: "",
      affiliateCommission: "",
      affiliateCommissionRein: null,
      annualConsumption: null,
      utilityCompanyName: "",
      roofAge: "",
      roofType: "",
      kindOfElectricPanel: "",
      mountingPreference: "",
      notKnowHOA: false,
      hoaName: "",
      hoaEmail: "",
      hoaPhone: "",
      productInterested: [],
      homeSecurityType: "",
      financing: "",
      work: "",
      leadStatus: "",
      additionalInfo: "",
      isExistingSystem: false,
    },
  });

  const { handleSubmit, control, trigger, watch, reset, setValue, formState } = methods;
  const [showMenteeTab, setShowMenteeTab] = useState(false);

  // Define field mappings for each section
  const sectionFields = {
    0:
      showMenteeTab && leadID
        ? [
            "menteeFirstName",
            "menteeLastName",
            "menteeEmail",
            "menteePhoneNumber",
          ]
        : ["firstName", "lastName", "emailAddress", "phoneNumber"],
    1:
      showMenteeTab && leadID
        ? ["firstName", "lastName", "emailAddress", "phoneNumber"]
        : ["streetAddress", "city", "state", "zipCode"],
    2:
      showMenteeTab && leadID
        ? businessType === dataConstant.HomeService.label
          ? [
              "streetAddress",
              "city",
              "state",
              "zipCode",
              "homeSecurityType",
              "productInterested",
            ]
          : ["streetAddress", "city", "state", "zipCode"]
        : businessType === dataConstant.HomeService.label
          ? ["homeSecurityType", "productInterested"]
          : [],
    3:
      businessType === dataConstant.HomeService.label
        ? showMenteeTab && leadID
          ? [
              "homeSecurityType",
              "productInterested",
              "searchableMentor",
              "StateIds",
              "LanguageIds",
              "mentor",
            ]
          : ["searchableMentor", "StateIds", "LanguageIds", "mentor"]
        : showMenteeTab && leadID
          ? ["searchableMentor", "StateIds", "LanguageIds", "mentor"]
          : ["searchableMentor", "StateIds", "LanguageIds", "mentor"],
    4:
      businessType === dataConstant.HomeService.label
        ? ["affiliate", "affiliateCommission", "affiliateCommissionSecurity"]
        : ["affiliate", "affiliateCommission", "affiliateCommissionRein"],
    5: [
      "annualConsumption",
      "utilityCompanyName",
      "roofAge",
      "roofType",
      "kindOfElectricPanel",
      "mountingPreference",
      "hoaName",
      "hoaEmail",
      "hoaPhone",
      "productInterested",
      "financing",
      "work",
      "leadStatus",
      "additionalInfo",
      "isExistingSystem",
      "notKnowHOA",
    ],
  };

  const sectionHasErrors = (index) => {
    const fields = sectionFields[index] || [];
    return fields.some((field) => formState.errors[field]);
  };

  const isSectionExpanded = (index) => {
    return expandedSections[index] !== false;
  };

  useEffect(() => {
    setExpandedSections((prev) => {
      let updated = false;
      const next = { ...prev };

      Object.keys(sectionFields).forEach((index) => {
        const idx = Number(index);
        if (
          sectionHasErrors(idx) &&
          prev[idx] === false &&
          autoOpenedSections[idx] !== false
        ) {
          next[idx] = true;
          updated = true;
        }
      });

      return updated ? next : prev;
    });
  }, [formState.errors, autoOpenedSections]);

  const watchedHomeSecurityType = watch("homeSecurityType");

  useEffect(() => {
    if (watchedHomeSecurityType && watchedHomeSecurityType.value) {
      setSelectedHomeSecurityType(watchedHomeSecurityType.value);
      if (selectedHomeSecurityType && selectedHomeSecurityType !== watchedHomeSecurityType.value) {
        setValue("productInterested", businessType === dataConstant.HomeService.label ? "" : "" );
        setValue("mentor", mentorDefaultValue);
        setDescription(""); 
        setDescriptionOn(false); 
      }
      if (watchedHomeSecurityType.value === dataConstant.LeadCollections.Internet) {
        setValue("productInterested", "");
      }
    } else {
      setSelectedHomeSecurityType("");
      if (selectedHomeSecurityType) {
        setValue("productInterested", businessType === dataConstant.HomeService.label ? "" : "");
        setValue("mentor", mentorDefaultValue);
        setDescription(""); 
        setDescriptionOn(false); 
      }
    }
  }, [watchedHomeSecurityType, setValue, businessType]);

  useEffect(() => {
    if (state.leadInfo.submitToFreedomForever) {
      const submitToFreedomForever = async () => {
        const isFormValid = await trigger();
        if (isFormValid) {
          setState((prev) => ({
            ...prev,
            isFinalSubmitDisabled: true,
            leadInfo: {
              ...prev.leadInfo,
            },
          }));
          handleSubmit(onSubmit)();
        } else {
          scrollToFirstErrorSection(formState.errors);
        }
      };
      submitToFreedomForever();
    }
  }, [state.finalSubmitCount]);

  useEffect(() => {
    if (state.submitToMentorCount !== 0) {
      const submitToMentor = async () => {
        const isFormValid = await trigger();
        if (isFormValid) {
          const leadStatusValue = _.find(
            leadStatusList,
            (i) =>
              i.value ===
              dataConstant.LeadCollections.LeadStatus.ApprovalPendingFromMentor
          );
          setState((prev) => ({
            ...prev,
            isFinalSubmitDisabled: true,
            leadInfo: {
              ...prev.leadInfo,
              leadStatus: leadStatusValue,
            },
          }));
          handleSubmit(onSubmit)();
        } else {
          scrollToFirstErrorSection(formState.errors);
        }
      };
      submitToMentor();
    }
  }, [state.submitToMentorCount]);

  useEffect(() => {
    if (state.submitCount !== 0) {
      const submitForm = async () => {
        const isFormValid = await trigger();
        if (isFormValid) {
          handleSubmit(onSubmit)();
        } else {
          scrollToFirstErrorSection(formState.errors);
        }
      };
      submitForm();
      setState((prevState) => ({
        ...prevState,
        isSubmitDisabled: true,
        isFinalSubmitDisabled: false,
      }));
    }
  }, [state.submitCount]);

  useEffect(() => {
    const { state } = location || {};
    const { IsMentor } = state || {};
    if (typeof IsMentor != "undefined") {
      isMentor = IsMentor;
    }
    if (typeof id !== "undefined") {
      leadID = id;
      isFormFieldDisable = false;
      isMentorButtonDisable = false;
      isRejected = false;
      isApprovalPenidng = false;
      setState((prevState) => ({
        ...prevState,
        formTitle:
          leadID > 0 ? formTitleEdit.toString() : formTitleAdd.toString(),
      }));
    } else {
      leadID = "";
      leadData = [];
      isFormFieldDisable = false;
      isMentorButtonDisable = false;
      isRejected = false;
      isApprovalPenidng = false;
      setState((prevState) => ({
        ...prevState,
        leadInfo: {
          ...prevState.leadInfo,
          defaultFiles: [],
        },
        formTitle: formTitleAdd.toString(),
      }));
    }
  }, []);

  useEffect(() => {
    if (businessType === "") {
      if (id !== undefined) {
        httpPost(
          urlConstant.LeadCollections.GetLeadBusinessTypeById,
          { LeadId: id },
          true,
          false,
          authenticationState.accessToken,
          authenticationState.impersonateEmail
        )
          .then((response) => {
            const getBusinessTypes =
              response?.Data?.BusinessType === undefined
                ? "Solar"
                : response?.Data?.BusinessType;
            setBusinessType(getBusinessTypes);
            setState((prevState) => ({
              ...prevState,
              formTitle: `${t(
                "LeadCollection.EditLead"
              )}  - ${getBusinessTypes}`,
            }));
          })
          .catch((err) => {
            console.error(err);
          });
      } else {
        httpGet(
          urlConstant.Common.GetBusinessTypeDropDownList,
          true,
          false,
          authenticationState.accessToken,
          authenticationState.impersonateEmail
        )
          .then((response) => {
            setState((prevState) => ({
              ...prevState,
              isAddLeadPopupOpen: true,
              projectList: response.Value.Data,
            }));
          })
          .catch((err) => {
            console.error(err);
          });
      }
    } else {
      getAffiliateDropDownList();
      if (businessType !== dataConstant.HomeService.label) {
        getSearchableMentorDropDownList();
      }
      getAllDropDownList();
      getStateDropDownList(1);
    }
  }, [businessType]);

  useEffect(() => {
    if (
      id !== undefined &&
      dropdownData.languageList.length > 0 &&
      state.isAffiliateDropDownCalled 
    ) {
      getLeadDetailsByID(leadID);
    }
  }, [
    dropdownData.languageList,
    state.isAffiliateDropDownCalled,
  ]);

  useEffect(() => {
    if (
      dropdownData.workList &&
      dropdownData.workList.length > 0 &&
      !methods.getValues("work")
    ) {
      methods.setValue("work", dropdownData.workList[0], {
        shouldValidate: true,
        shouldDirty: true,
      });
    }
  }, [dropdownData.workList]);

  const getAllDropDownList = () => {
    const dropDownTypes = [
      dataConstant.AllDropDown.LanguageDropDown,
      dataConstant.AllDropDown.ReinH2OFinancingDropDown,
      dataConstant.AllDropDown.LeadFinancingDropDown,
      dataConstant.AllDropDown.ProductInterestedDropDown,
      dataConstant.AllDropDown.LeadRoofAgeDropDown,
      dataConstant.AllDropDown.LeadRoofTypeDropDown,
      dataConstant.AllDropDown.LeadMountingPreferenceDropDown,
      dataConstant.AllDropDown.LeadWorkDropDown,
      dataConstant.AllDropDown.LeadStatusDropDown,
      dataConstant.AllDropDown.LeadKindofElectricalPanelDropDown,
      dataConstant.AllDropDown.AffiliateCommissionDropDown,
      dataConstant.AllDropDown.ReinAffiliateCommissionDropDown,
      dataConstant.AllDropDown.SecurityAffiliateCommissionDropDown,
      dataConstant.AllDropDown.SecurityFinancingDropDown,
      dataConstant.AllDropDown.LeadHomeSecurityTypeDropDown,
      dataConstant.AllDropDown.LeadADTHomeSecurityProductInterestedDropDown,
      dataConstant.AllDropDown.LeadBrinksHomeSecurityProductInterestedDropDown,
      dataConstant.AllDropDown.LeadInternetMobilePhoneHomeSecurityProductInterestedDropDown
    ];
    const model = {
      DropDownTypes: dropDownTypes.join(),
    };

    httpPost(
      urlConstant.Common.GetAllDropDownData,
      model,
      true,
      true,
      authenticationState.accessToken,
      authenticationState.impersonateEmail
    )
      .then((response) => {
        languageList = response?.Value?.LanguageDropDownResult?.Data || [];
        financingList =
          businessType === dataConstant.ReinH2O.label
            ? response?.Value?.ReinH2OFinancingResult?.Data || []
            : businessType === dataConstant.HomeService.label
            ? response?.Value?.SecurityFinancingResult?.Data || []
            : response?.Value?.LeadFianancingResult?.Data || [];
        productInterestedList = response?.Value?.ProductInterestedResult?.Data || [];
        roofAgeList = response?.Value?.LeadRoofAgeResult?.Data || [];
        roofTypeList = response?.Value?.LeadRoofTypeResult?.Data || [];
        mountingPreferenceList = response?.Value?.LeadMountingPreferenceResult?.Data || [];
        workList = response?.Value?.LeadWorkResult?.Data || [];
        leadStatusList = response?.Value?.LeadStatusResult?.Data || [];
        affiliateCommissionList =
          businessType === dataConstant.ReinH2O.label
            ? response?.Value?.ReinAffiliateCommissionResult?.Data || []
            : businessType === dataConstant.HomeService.label
            ? response?.Value?.SecurityAffiliateCommissionResult?.Data || []
            : response?.Value?.AffiliateCommissionResult?.Data || [];
        kindOfElectricPanelList = response?.Value?.LeadKindofElectricalPanelResult?.Data || [];

        homeSecurityTypeList = response?.Value?.LeadHomeSecurityTypeResult?.Data || [];
        adtHomeSecurityProductInterestedList = response?.Value?.LeadADTHomeSecurityProductInterestedResult?.Data || [];
        brinksHomeSecurityProductInterestedList = response?.Value?.LeadBrinksHomeSecurityProductInterestedResult?.Data || [];
        internetMobilePhoneHomeSecurityProductList = response?.Value?.LeadInternetMobilePhoneHomeSecurityProductInterestedResult?.Data || [];

        setDropdownData((prev) => ({
          ...prev,
          languageList: languageList,
          financingList: financingList,
          productInterestedList: productInterestedList,
          roofAge: roofAgeList,
          roofType: roofTypeList,
          mountingPreference: mountingPreferenceList,
          affiliateCommissionList: affiliateCommissionList,
          workList: workList,
          kindOfElectricPanelList: kindOfElectricPanelList,
          leadStatusList: leadStatusList,
          homeSecurityTypeList: homeSecurityTypeList,
          adtHomeSecurityProductInterestedList: adtHomeSecurityProductInterestedList,
          brinksHomeSecurityProductInterestedList: brinksHomeSecurityProductInterestedList,
          internetMobilePhoneHomeSecurityProductList: internetMobilePhoneHomeSecurityProductList
        }));
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        if (leadID === "") {
          setShowMenteeTab(false);
          setState((prevState) => ({
            ...prevState,
            isDisplay: true,
          }));
        }
      });
  };

  const getLeadDetailsByID = (ID) => {
    const getleadDetailsURL = `${urlConstant.LeadCollections.GetLeadCollectionDetailsById}?LeadID=${ID}`;
    httpGet(
      getleadDetailsURL,
      true,
      true,
      authenticationState.accessToken,
      authenticationState.impersonateEmail
    )
      .then((response) => {
        if (response.Value.Status === dataConstant.APIResponseStatus.Failure) {
          showSnackbar(response.Value.Message, "error");
          setTimeout(() => {
            navigate("/projects");
          }, 2000);
        } else {
          leadData = response.Value.Data;
          isFormFieldDisable =
            (businessType === dataConstant.Solar.label &&
              leadData.FreedomForeverLeadId > 0) ||
            ((businessType === dataConstant.ReinH2O.label ||
              businessType === dataConstant.HomeService.label) &&
              !(
                leadData.LeadStatus.toLowerCase() ===
                  dataConstant.LeadCollections.LeadStatus.New.toLowerCase() ||
                leadData.LeadStatus.toLowerCase() ===
                  dataConstant.LeadCollections.LeadStatus.RejectedByMentor.toLowerCase()
              )) ||
            leadData.LeadStatus.toLowerCase() ===
              dataConstant.LeadCollections.LeadStatus.ApprovalPendingFromMentor.toLowerCase()
              ? true
              : false;
          if (isMentor) {
            isFormFieldDisable = true;
          }
          isMentorButtonDisable =
            (businessType === dataConstant.Solar.label &&
              leadData.FreedomForeverLeadId > 0) ||
            ((businessType === dataConstant.ReinH2O.label ||
              businessType === dataConstant.HomeService.label) &&
              !(
                leadData.LeadStatus.toLowerCase() ===
                  dataConstant.LeadCollections.LeadStatus.ApprovalPendingFromMentor.toLowerCase() ||
                leadData.LeadStatus.toLowerCase() ===
                  dataConstant.LeadCollections.LeadStatus.New.toLowerCase()
              ))
              ? true
              : false;
          let stateValue = commonDefaultValue;
          if (leadData.StateID === null) {
            stateValue = commonDefaultValue;
          } else {
            stateValue = _.find(stateList, (i) => {
              return i.value === leadData.StateID;
            });
          }

          let roofAgeValue = roofAgeDefaultValue;
          if (leadData.RoofAge === null) {
            roofAgeValue = roofAgeDefaultValue;
          } else {
            roofAgeValue = _.find(roofAgeList, (i) => {
              return i.value === leadData.RoofAge;
            });
          }
          const isMentee =
            leadData.Mentor === userDetails?.UserAccountDetails?.AcctID &&
            leadData.AcctID !== userDetails?.UserAccountDetails?.AcctID;
          if (isMentee) {
            setShowMenteeTab(true);
          }
          let roofTypeValue = roofTypeDefaultValue;
          if (leadData.RoofType === null) {
            roofTypeValue = roofTypeDefaultValue;
          } else {
            roofTypeValue = _.find(roofTypeList, (i) => {
              return i.value === leadData.RoofType;
            });
          }

          let kindOfElectricPanelValue = commonDefaultValue;
          if (leadData.KindOfElectricPanel === null) {
            kindOfElectricPanelValue = commonDefaultValue;
          } else {
            kindOfElectricPanelValue = _.find(kindOfElectricPanelList, (i) => {
              return i.value === leadData.KindOfElectricPanel;
            });
          }

          let mountingPreferenceValue = commonDefaultValue;
          if (leadData.MountingPreference === null) {
            mountingPreferenceValue = commonDefaultValue;
          } else {
            mountingPreferenceValue = _.find(mountingPreferenceList, (i) => {
              return i.value === leadData.MountingPreference;
            });
          }

          let financingValue = commonDefaultValue;
          if (leadData.Financing === null) {
            financingValue = commonDefaultValue;
          } else {
            financingValue = _.find(financingList, (i) => {
              return i.value === leadData.Financing;
            });
          }

          let workValue = commonDefaultValue;
          if (leadData.Work === null) {
            workValue = commonDefaultValue;
          } else {
            workValue = _.find(workList, (i) => {
              return i.value === leadData.Work;
            });
          }

          let homeSecurityTypeValue = commonDefaultValue;
          if (businessType === dataConstant.HomeService.label) {
            if (leadData.HomeSecurityType === null) {
              homeSecurityTypeValue = commonDefaultValue;
            } else {
              homeSecurityTypeValue = _.find(homeSecurityTypeList, (i) => {
                return i.value === leadData.HomeSecurityType;
              });
            }
          }

          let affiliateValue = commonDefaultValue;
          if (leadData.AffiliateDetails != null) {
            affiliateList = leadData.AffiliateDetails;
            setDropdownData((prev) => ({
              ...prev,
              affiliateData: affiliateList,
            }));

            if (leadData.AffiliateId === null) {
              affiliateValue = affiliateDefaultValue;
            } else {
              affiliateValue = _.find(affiliateList, (i) => {
                return i.value === leadData.AffiliateId;
              });
            }
            if (affiliateValue === undefined) {
              affiliateValue = _.find(affiliateList, (i) => {
                return i.value === leadData.AffiliateId;
              });
            }
          }

          let affiliateCommissionValue = affiliateCommissionDefaultValue;
          if (businessType === dataConstant.Solar.label) {
            if (leadData.AffiliateCommission === null) {
              affiliateCommissionValue = affiliateCommissionDefaultValue;
            } else {
              affiliateCommissionValue = _.find(
                affiliateCommissionList,
                (i) => {
                  return i.value === leadData.AffiliateCommission;
                }
              );
            }
          }
          let mentorValue = commonDefaultValue;
          let descriptionValue = "";
          if (leadData.MentorDetails != null) {
            setShowMentor(true);
            mentorList = leadData.MentorDetails;
            setDropdownData((prev) => ({
              ...prev,
              mentor: mentorList,
            }));
            if (leadData.MentorDetails[0].Description !== null) {
              descriptionValue = leadData.MentorDetails[0].Description;
              setDescription(descriptionValue);
              setDescriptionOn(true);
            }

            if (leadData.Mentor === null) {
              mentorValue = commonDefaultValue;
            } else {
              mentorValue = _.find(mentorList, (i) => {
                return i.value === leadData.Mentor;
              });
            }

            if (leadData.Mentor === userDetails?.UserAccountDetails?.AcctID) {
              isMentor = true;
              setMentorFlag(true);
            }
            if (
              leadData.Mentor === userDetails?.UserAccountDetails?.AcctID &&
              leadData.MenteeDetails.AcctID === leadData.Mentor
            ) {
              setSelfMentorFlag(true);
            }
          } else {
            setShowMentor(false);
          }

          let leadStatusValue = LeadStatusDefaultValue;
          if (leadData.LeadStatus === null) {
            leadStatusValue = _.find(leadStatusList, (i) => {
              return i.value === dataConstant.LeadCollections.LeadStatus.New;
            });
          } else {
            leadStatusValue = _.find(leadStatusList, (i) => {
              return i.value === leadData.LeadStatus;
            });
          }

          if (
            leadData.UtilitiBills !== null &&
            leadData.UtilitiBills.length > 0
          ) {
            const filePromises = leadData?.UtilitiBills?.map((bill) => {
              return {
                id: bill.Id,
                images: bill.StoredPath,
                originalFileName: bill.FileName,
                isFromAPI: true,
                fileExtension: bill.StoredPath?.split('.').pop().split('?')[0].toLowerCase()
              };
            });
            setUploadedFile(filePromises);
          } else {
            setUploadedFile([]);
          }

          let SelectedProductInterestedList = null;
          if (leadData.ProductInterested !== null) {
            const selectedProducts = leadData.ProductInterested.split(",").map(
              (product) => product.trim()
            );
            
            let appropriateProductList = productInterestedList;
            if (businessType === dataConstant.HomeService.label && leadData.HomeSecurityType) {
              if (leadData.HomeSecurityType === dataConstant.LeadCollections.AdtHomeSecurity) {
                appropriateProductList = adtHomeSecurityProductInterestedList;
              } else if (leadData.HomeSecurityType === dataConstant.LeadCollections.BrinksHomeSecurity) {
                appropriateProductList = brinksHomeSecurityProductInterestedList;
              }else if (leadData.HomeSecurityType === dataConstant.LeadCollections.MobilePhone || leadData.HomeSecurityType === dataConstant.LeadCollections.InternetAndMobilePhone) {
                appropriateProductList = internetMobilePhoneHomeSecurityProductList ;
              }
            }
            
            if (businessType === dataConstant.HomeService.label) {
              const matchedProduct = _.find(appropriateProductList, (b) => {
                return selectedProducts.indexOf(b.value) > -1;
              });
              SelectedProductInterestedList = matchedProduct || null;
            } else {
              SelectedProductInterestedList = _.filter(
                appropriateProductList,
                (b) => {
                  return selectedProducts.indexOf(b.value) > -1;
                }
              );
            }
          }
          const formData = {
            firstName: leadData.FirstName || "",
            lastName: leadData.LastName || "",
            phoneNumber: leadData.Phone || "",
            streetAddress: leadData.StreetAddress || "",
            emailAddress: leadData.PublicEmail || "",
            city: leadData.City || "",
            zipCode: leadData.ZipCode || "",
            state: stateValue?.value || null,
            utilityCompanyName: leadData.UtilityCompanyName || "",
            annualConsumption: leadData.AnnualConsumption || null,
            roofAge: roofAgeValue || roofAgeDefaultValue,
            roofType: roofTypeValue || roofTypeDefaultValue,
            kindOfElectricPanel: kindOfElectricPanelValue || commonDefaultValue,
            mountingPreference: mountingPreferenceValue || commonDefaultValue,
            financing: financingValue || commonDefaultValue,
            work: workValue || commonDefaultValue,
            isExistingSystem: leadData.IsExistingSystem || false,
            notKnowHOA: leadData.NotKnowHOA || false,
            hoaName: leadData.HOAName || "",
            hoaPhone: leadData.HOAPhone || "",
            hoaEmail: leadData.HOAEmail || "",
            mentor: mentorValue || commonDefaultValue,
            leadStatus: leadStatusValue || LeadStatusDefaultValue,
            additionalInfo: leadData.AdditionalInformation || "",
            affiliate: affiliateValue || commonDefaultValue,
            affiliateCommission:
              affiliateCommissionValue || affiliateCommissionDefaultValue,
            description: descriptionValue || "",
            productInterested: businessType === dataConstant.HomeService.label 
              ? (SelectedProductInterestedList || "")
              : (SelectedProductInterestedList || []),
            homeSecurityType: businessType === dataConstant.HomeService.label ? (homeSecurityTypeValue || commonDefaultValue) : "",
            affiliateCommissionRein:
              businessType === dataConstant.ReinH2O.label
                ? leadData.AffiliateCommission || null
                : null,
            affiliateCommissionSecurity:
              businessType === dataConstant.HomeService.label
                ? leadData.AffiliateCommission
                : null,
            StateIds: [],
            LanguageIds: [],
          };
          reset(formData);
          
          if (businessType === dataConstant.HomeService.label && leadData.HomeSecurityType) {
            setSelectedHomeSecurityType(leadData.HomeSecurityType);
          } else {
            setSelectedHomeSecurityType("");
          }
          
          if (leadData.MenteeDetails != null) {
            const { FirstName, LastName, EmailAddress, PhoneNumber } =
              leadData.MenteeDetails;
            setValue("menteeFirstName", FirstName);
            setValue("menteeLastName", LastName);
            setValue("menteeEmail", EmailAddress);
            setValue("menteePhoneNumber", PhoneNumber);
          }
          setState((prevState) => ({
            ...prevState,
            isDisplay: true,
            leadInfo: {
              ...prevState.leadInfo,
              acctID: leadData.AcctID,
              firstName: leadData.FirstName,
              lastName: leadData.LastName,
              state: stateValue?.value || null,
              isExistingSystem: leadData.IsExistingSystem,
              leadStatus: leadStatusValue,
              mentor: leadData.MentorDetails,
              assignYouselfMentor: leadData.AssignYourselfMentor,
              productInterested: SelectedProductInterestedList,
              affiliateCommissionRein:
                businessType === dataConstant.ReinH2O.label
                  ? leadData.AffiliateCommission
                  : null,
              affiliateCommissionSecurity:
                businessType === dataConstant.HomeService.label
                  ? leadData.AffiliateCommission
                  : null,
              isCreditForm: leadData.IsCreditForm,
            },
          }));
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const getStateDropDownList = (countryId) => {
    if (countryId !== null) {
      httpGet(
        `${urlConstant.Common.GetStateList}?CountryId=${countryId}`,
        true,
        true,
        authenticationState.accessToken,
        authenticationState.impersonateEmail
      )
        .then((response) => {
          stateList = response.Value.Data;
          setDropdownData((prev) => ({
            ...prev,
            states: stateList,
          }));
          setState((prevState) => ({
            ...prevState,
            leadInfo: {
              ...prevState.leadInfo,
              state: stateDefaultValue,
            },
          }));
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          if (leadData !== dataConstant.Undefined) {
            if (leadData.StateID !== null) {
              let stateValue = stateDefaultValue;
              if (leadData.StateID > 0) {
                stateValue = _.find(stateList, (i) => {
                  return i.value === leadData.StateID;
                });
              } else {
                stateValue = stateDefaultValue;
              }
              setState((prevState) => ({
                ...prevState,
                leadInfo: {
                  ...prevState.leadInfo,
                  state: stateValue,
                },
              }));
            }
          }
        });
    }
  };

  const getAffiliateDropDownList = () => {
    httpGet(
      `${urlConstant.LeadCollections.LeadAffiliateList}`,
      true,
      true,
      authenticationState.accessToken,
      authenticationState.impersonateEmail
    )
      .then((response) => {
        affiliateList = response.Value.Data;
        setState((prevState) => ({
          ...prevState,
          isAffiliateDropDownCalled: true,
        }));
        setDropdownData((prev) => ({
          ...prev,
          affiliateData: affiliateList,
        }));
      })
      .catch((err) => {
        console.error(err);
      });
  };

  function getHomeSecurityType(value) {
    const mapping = {
      [dataConstant.LeadCollections.AdtHomeSecurity]: "ADTHomeSecurity",
      [dataConstant.LeadCollections.BrinksHomeSecurity]: "BRINKSHomeSecurity",
      [dataConstant.LeadCollections.Internet]: "Internet",
      [dataConstant.LeadCollections.MobilePhone]: "MobilePhone",
      [dataConstant.LeadCollections.InternetAndMobilePhone]: "BothInternetMobilePhone",
    };

    return mapping[value] ?? null;
  }

  const getSearchableMentorDropDownList = () => {
    const searchParams = new URLSearchParams();
    if (businessType != null) {
      searchParams.set("BusinessType", businessType);
      if (businessType === dataConstant.HomeService.label && watchedHomeSecurityType?.value) {
        searchParams.set("HomeSecurityType", getHomeSecurityType(watchedHomeSecurityType?.value));
      }
    }
    searchParams.set("IsSearch", true);
    const getSearchMentorListURL = `${
      urlConstant.LeadCollections.LeadMentorSearchList
    }?${searchParams.toString()}`;
    httpGet(
      getSearchMentorListURL,
      true,
      true,
      authenticationState.accessToken,
      authenticationState.impersonateEmail
    )
      .then((response) => {
        searchableMentorList = response?.Value?.Data || [];
        setState((prevState) => ({
          ...prevState,
          isMentorSearchableDropDownCalled: true,
        }));
        setDropdownData((prev) => ({
          ...prev,
          searchableMentor: searchableMentorList,
        }));
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const isHOAHide = watch("notKnowHOA");
  const handleSearchlanguageChange = (SelectedLanguage) => {
    setsearchlanguages(SelectedLanguage);
  };

  const handleSearchStateChange = (selectedStates) => {
    setsearchStates(selectedStates);
  };

  const handleHomeSecurityPackagesOpen = () => {
    setState((prevState) => ({
      ...prevState,
      isHomeSecurityPackagesPopupOpen: true,
    }));
  };

  const handleHomeSecurityPackagesClose = () => {
    setState((prevState) => ({
      ...prevState,
      isHomeSecurityPackagesPopupOpen: false,
    }));
  };

  const getProductInterestedList = () => {
    if (businessType === dataConstant.HomeService.label) {
      if (selectedHomeSecurityType === dataConstant.LeadCollections.AdtHomeSecurity) {
        return dropdownData.adtHomeSecurityProductInterestedList;
      } else if (selectedHomeSecurityType === dataConstant.LeadCollections.BrinksHomeSecurity) {
        return dropdownData.brinksHomeSecurityProductInterestedList;
      }else if (selectedHomeSecurityType === dataConstant.LeadCollections.MobilePhone || selectedHomeSecurityType === dataConstant.LeadCollections.InternetAndMobilePhone) {
        return dropdownData.internetMobilePhoneHomeSecurityProductList;
      }
      return [];
    }
    return dropdownData.productInterestedList; 
  };

  const handleHomeSecurityTypePackageImgDownload = async () => {
    let fileUrl = '';
    let fileName = '';

    if (selectedHomeSecurityType === dataConstant.LeadCollections.AdtHomeSecurity) {
      fileUrl = `${process.env.REACT_APP_BLOB_URL}/backoffice-assets/ADTHomeSecurityPackage.png`;
      fileName = 'ADT_BYLD_HomeSecurityPackage.png';
    } else if (selectedHomeSecurityType === dataConstant.LeadCollections.BrinksHomeSecurity) {
      fileUrl = `${process.env.REACT_APP_BLOB_URL}/backoffice-assets/BrinksHomeSecurityPackage.jpg`;
      fileName = 'BRINKS_BYLD_HomeSecurityPackage.jpg';
    }

    try {
      const response = await fetch(fileUrl, { mode: 'cors' });
      const blob = await response.blob();

      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();

      // Clean up
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error('Download failed:', error);
    }
  };

  const getHomeSecurityPackageInfo = () => {
    if (selectedHomeSecurityType === dataConstant.LeadCollections.AdtHomeSecurity) {
      return {
        title: t("LeadCollection.ADTPackagesTitle"),
        linkText: t("LeadCollection.ViewADTPackages"),
        imageUrl: `${process.env.REACT_APP_BLOB_URL}/backoffice-assets/ADTHomeSecurityPackage.png`
      };
    } else if (selectedHomeSecurityType === dataConstant.LeadCollections.BrinksHomeSecurity) {
      return {
        title: t("LeadCollection.BRINKSPackagesTitle"),
        linkText: t("LeadCollection.ViewBRINKSPackages"),
        imageUrl: `${process.env.REACT_APP_BLOB_URL}/backoffice-assets/BrinksHomeSecurityPackage.png`
      };
    }
    return null;
  };

  const handleSearchableMentorChange = (e) => {
    setSearchText(e ? e.label : null);
    setState((prevValue) => ({
      ...prevValue,
      leadInfo: {
        ...prevValue.leadInfo,
        searchableMentor: e,
      },
    }));
  };

  const handleMentorChange = (e) => {
    setShouldKeepMentorDropdownOpen(false);
    if (e && e.value) {
      if (e.value === userDetails?.UserAccountDetails?.AcctID) {
        isMentor = true;
        setMentorFlag(true);
        setSelfMentorFlag(true);
      } else {
        isMentor = false;
        setMentorFlag(false);
        setSelfMentorFlag(false);
      }
      setDescription(e.Description);
      if (e.Description !== null) {
        setDescriptionOn(true);
      } else {
        setDescriptionOn(false);
      }
      setState((prevValue) => ({
        ...prevValue,
        leadInfo: {
          ...prevValue.leadInfo,
          mentor: [e],
          assignYouselfMentor:
            e.value === userDetails?.UserAccountDetails?.AcctID ? true : false,
          description: e.Description,
        },
      }));
    } else {
      console.error("Invalid mentor object or missing AcctID property");
    }
  };

  const annualConsumptionValidator = (value) => {
    if (!value) {
      return true;
    }
    const numericValue = parseFloat(value);
    if (!dataConstant.NumberAndNull.test(value)) {
      return t("LeadCollection.invalidInput");
    } else if (numericValue > 1000000) {
      return t("LeadCollection.lessThanMillion");
    }
    return true;
  };

  const affiliateCommissionReinValidator = (value) => {
    if (!value || value.trim() === "") {
      return true;
    }
    const numericValue = parseFloat(value);
    if (!dataConstant.NumberAndNull.test(value)) {
      return t("LeadCollection.invalidInput");
    } else if (numericValue > 1000) {
      return t("LeadCollection.lessThanThousand");
    }
    return true;
  };

  const firstNameLabelKey =
    businessType === dataConstant.ReinH2O.label ||
    businessType === dataConstant.HomeService.label
      ? t("LeadCollection.ReinH2O.CustomerFirstName")
      : t("LeadCollection.FirstNameLable");
  const lastNameLabelKey =
    businessType === dataConstant.ReinH2O.label ||
    businessType === dataConstant.HomeService.label
      ? t("LeadCollection.ReinH2O.CustomerLastName")
      : t("LeadCollection.LastNameLable");

  const formConfig = {
    firstName: {
      name: "firstName",
      type: "text",
      required: true,
      label: t(firstNameLabelKey),
      maxLength: dataConstant.MinMaxLength.CharLimit50,
      validation: {
        validate: nameValidator(firstNameLabelKey),
      },
      isDisabled: isFormFieldDisable,
      tabIndex: 1,
    },
    lastName: {
      name: "lastName",
      type: "text",
      required: true,
      label: t(lastNameLabelKey),
      maxLength: dataConstant.MinMaxLength.CharLimit50,
      validation: {
        validate: nameValidator(lastNameLabelKey),
      },
      isDisabled: isFormFieldDisable,
      tabIndex: 2,
    },
    emailAddress: {
      name: "emailAddress",
      type: "email",
      required: true,
      label: t(
        businessType === dataConstant.ReinH2O.label ||
          businessType === dataConstant.HomeService.label
          ? t("LeadCollection.ReinH2O.CustomerEmailAddress")
          : t("LeadCollection.EmailLable")
      ),
      maxLength: dataConstant.MinMaxLength.CharLimit50,
      isDisabled: isFormFieldDisable,
      tabIndex: 3,
    },
    phoneNumber: {
      name: "phoneNumber",
      type: "text",
      required: true,
      label: t(
        businessType === dataConstant.ReinH2O.label ||
          businessType === dataConstant.HomeService.label
          ? t("LeadCollection.ReinH2O.CustomerPhoneNumber")
          : t("LeadCollection.PhoneLable")
      ),
      maxLength: dataConstant.MinMaxLength.CharLimit10,
      validation: {
        validate: phoneNumberValidator(
          businessType === dataConstant.ReinH2O.label
            ? t("LeadCollection.ReinH2O.CustomerPhoneNumber")
            : t("LeadCollection.PhoneLable")
        ),
      },
      isDisabled: isFormFieldDisable,
      tabIndex: 4,
    },
    menteeFirstName: {
      name: "menteeFirstName",
      type: "text",
      label: t("LeadCollection.MenteeDetails.FirstNameLable"),
      isDisabled: true,
    },
    menteeLastName: {
      name: "menteeLastName",
      type: "text",
      isDisabled: true,
      label: t("LeadCollection.MenteeDetails.LastNameLable"),
    },
    menteeEmail: {
      name: "menteeEmail",
      type: "email",
      label: t("LeadCollection.MenteeDetails.EmailLable"),
      isDisabled: true,
    },
    menteePhoneNumber: {
      name: "menteePhoneNumber",
      type: "text",
      label: t("LeadCollection.MenteeDetails.PhoneLable"),
      isDisabled: true,
    },
    streetAddress: {
      name: "streetAddress",
      type: "text",
      label: t("LeadCollection.StreetAddressLable"),
      required: isFinalSubmit,
      maxLength: dataConstant.MinMaxLength.CharLimit50,
      isDisabled: isFormFieldDisable,
    },
    city: {
      name: "city",
      type: "text",
      label: t("LeadCollection.CityLable"),
      required: isFinalSubmit,
      isDisabled: isFormFieldDisable,
      maxLength: dataConstant.MinMaxLength.CharLimit50,
    },
    state: {
      name: "state",
      label: t("LeadCollection.StateLable"),
      dropDownList: dropdownData.states,
      required: isFinalSubmit,
      isDisabled: isFormFieldDisable,
    },
    zipCode: {
      name: "zipCode",
      type: "text",
      label: t("LeadCollection.ZipCodeLable"),
      required: isFinalSubmit,
      maxLength: dataConstant.MinMaxLength.CharLimit5,
      isDisabled: isFormFieldDisable,
      validation: {
        validate: zipCodeValidator(t("LeadCollection.ZipCodeLable")),
      },
    },
    searchableMentor: {
      name: "searchableMentor",
      type: "dropdown",
      label: t("LeadCollection.SearchMentor"),
      dropDownList: dropdownData.searchableMentor,
      customOnChange: handleSearchableMentorChange,
      isDisabled: isFormFieldDisable,
    },
    StateIds: {
      name: "StateIds",
      type: "multiSelect",
      label: t("LeadCollection.SelectStatesLabel"),
      dropDownList: dropdownData.states,
      customOnChange: handleSearchStateChange,
      isDisabled: isFormFieldDisable,
    },
    LanguageIds: {
      name: "LanguageIds",
      type: "multiSelect",
      label: t("LeadCollection.SelectLanguagesLabel"),
      dropDownList: dropdownData.languageList,
      customOnChange: handleSearchlanguageChange,
      isDisabled: isFormFieldDisable,
    },
    mentor: {
      name: "mentor",
      type: "dropdown",
      label: t("LeadCollection.Mentor"),
      dropDownList: dropdownData.mentor,
      keepOpen: shouldKeepMentorDropdownOpen,
      isDisabled: !showMentor || isFormFieldDisable,
      customOnChange: handleMentorChange,
    },
    affiliate: {
      name: "affiliate",
      type: "dropdown",
      label: t("LeadCollection.Affiliate"),
      dropDownList: dropdownData.affiliateData,
      isDisabled: isFormFieldDisable || isMentor,
    },
    affiliateCommission: {
      name: "affiliateCommission",
      type: "dropdown",
      label: t("LeadCollection.AffiliateCommission"),
      dropDownList: dropdownData.affiliateCommissionList,
      isDisabled: isFormFieldDisable || isMentor,
    },
    affiliateCommissionRein: {
      name: "affiliateCommissionRein",
      label: t("LeadCollection.AffiliateCommission"),
      validation: {
        validate: affiliateCommissionReinValidator,
      },
      isDisabled: isFormFieldDisable || isMentor,
    },
    affiliateCommissionSecurity: {
      name: "affiliateCommissionSecurity",
      label: t("LeadCollection.AffiliateCommission"),
      validation: {
        validate: affiliateCommissionReinValidator,
      },
      isDisabled: isFormFieldDisable || isMentor,
    },
    annualConsumption: {
      name: "annualConsumption",
      type: "text",
      label: t("LeadCollection.AnnualConsumptionLable"),
      validation: {
        validate: annualConsumptionValidator,
      },
      isDisabled: isFormFieldDisable,
    },
    utilityCompanyName: {
      name: "utilityCompanyName",
      type: "text",
      label: t("LeadCollection.CompanyLable"),
      maxLength: dataConstant.MinMaxLength.CharLimit50,
      isDisabled: isFormFieldDisable,
    },
    roofAge: {
      name: "roofAge",
      type: "dropdown",
      label: t("LeadCollection.RoofAgeLable"),
      dropDownList: dropdownData.roofAge,
      isDisabled: isFormFieldDisable,
    },
    roofType: {
      name: "roofType",
      type: "dropdown",
      label: t("LeadCollection.RoofTypeLable"),
      dropDownList: dropdownData.roofType,
      isDisabled: isFormFieldDisable,
    },
    kindOfElectricPanel: {
      name: "kindOfElectricPanel",
      type: "dropdown",
      label: t("LeadCollection.ElectricPanelLable"),
      dropDownList: dropdownData.kindOfElectricPanelList,
      isDisabled: isFormFieldDisable,
    },
    mountingPreference: {
      name: "mountingPreference",
      type: "dropdown",
      label: t("LeadCollection.MountingPrefLable"),
      dropDownList: dropdownData.mountingPreference,
      isDisabled: isFormFieldDisable,
    },
    hoaName: {
      name: "hoaName",
      type: "text",
      label: t("LeadCollection.HOANameLable"),
      maxLength: dataConstant.MinMaxLength.CharLimit50,
      isDisabled: isFormFieldDisable,
    },
    hoaEmail: {
      name: "hoaEmail",
      type: "email",
      label: t("LeadCollection.HOAEmailLable"),
      maxLength: dataConstant.MinMaxLength.CharLimit50,
      isDisabled: isFormFieldDisable,
    },
    hoaPhone: {
      name: "hoaPhone",
      type: "text",
      label: t("LeadCollection.HOAPhoneLable"),
      maxLength: dataConstant.MinMaxLength.CharLimit15,
      isDisabled: isFormFieldDisable,
      validation: {
        validate: phoneNumberValidator(t("LeadCollection.HOAPhoneLable")),
      },
    },
    productInterested: {
      name: "productInterested",
      type: businessType === dataConstant.HomeService.label ? "dropdown" : "multiselect",
      label: t("LeadCollection.ReinH2O.ProductInterestedLabel"),
      isDisabled: isFormFieldDisable || (businessType === dataConstant.HomeService.label && !selectedHomeSecurityType) ||
                                        (businessType === dataConstant.HomeService.label && watchedHomeSecurityType?.value === dataConstant.LeadCollections.Internet),
      dropDownList: getProductInterestedList(),     
    },
    homeSecurityType: {
      name: "homeSecurityType",
      type: "dropdown",
      label: t("LeadCollection.HomeServiceType"),
      dropDownList: dropdownData.homeSecurityTypeList,
      required: businessType === dataConstant.HomeService.label,
      isDisabled: isFormFieldDisable,
      isVisible: businessType === dataConstant.HomeService.label,
      customOnChange: (selectedValue) => {
        if (businessType === dataConstant.HomeService.label &&selectedValue?.value) {
          getSearchableMentorDropDownList(selectedValue.value);
      }
  }
    },
    financing: {
      name: "financing",
      type: "dropdown",
      label:
        businessType === dataConstant.ReinH2O.label
          ? t("LeadCollection.PurchaseType")
          : t("LeadCollection.Financing"),
      dropDownList: dropdownData.financingList,
      isDisabled: isFormFieldDisable,
    },
    work: {
      name: "work",
      type: "dropdown",
      label: t("LeadCollection.Work"),
      dropDownList: dropdownData.workList,
      required: true,
      isDisabled: isFormFieldDisable,
    },
    leadStatus: {
      name: "leadStatus",
      type: "dropdown",
      label: t("LeadCollection.LeadStatus"),
      isDisabled: true,
      dropDownList: dropdownData.leadStatusList,
      isPlaceholder: false,
    },
    additionalInfo: {
      name: "additionalInfo",
      type: "textarea",
      label: t("LeadCollection.InfoLable"),
      maxLength:
        businessType === dataConstant.ReinH2O.label
          ? dataConstant.MinMaxLength.CharLimit500
          : dataConstant.MinMaxLength.CharLimit200,
    },
  };

  const handleImageChange = (files) => {
    if (files?.length > 0) {
      const newFiles = files.map((file, index) => ({
        id: Date.now() + index,
        images: [URL.createObjectURL(file)],
        originalFileName: file.name,
        file: file,
        isFromAPI: false,
        fileExtension: file.name?.split('.').pop().split('?')[0].toLowerCase()
      }));
      const updatedFiles = [...uploadedFile, ...newFiles];
      setUploadedFile(updatedFiles);
      setState((prev) => ({
        ...prev,
        imageDisplay: true,
        uploadBills: updatedFiles,
      }));
    }
  };

  const handleDeleteImage = (id) => {
    setState((prevState) => ({
      ...prevState,
      isUploadFileDeletePopupOpen: leadID > 0,
      isDeletedPopupOpen: leadID <= 0,
      selectedDeletedImage: id,
    }));
  };

  const handleYesDeletePopupModal = () => {
    const updatedUploadBills = state.uploadBills.filter(
      (data) => data.id !== state.selectedDeletedImage
    );
    const updatedUploadedFiles = uploadedFile.filter(
      (file) => file.id !== state.selectedDeletedImage
    );
    setState((prevState) => ({
      ...prevState,
      uploadBills: updatedUploadBills,
      isDeletedPopupOpen: false,
      selectedDeletedImage: "",
    }));
    setUploadedFile(updatedUploadedFiles);
  };

  const handleNoDeletePopupModal = () => {
    setState((prevState) => ({
      ...prevState,
      isDeletedPopupOpen: false,
      selectedDeletedImage: "",
    }));
  };

  const handleYesUploadedDeletePopupModal = () => {
    const model = {
      ID: state.selectedDeletedImage,
    };

    const deleteURL = urlConstant.LeadCollections.DeleteUplodedMedia;
    const formData = new FormData();
    for (let i = 0; i < uploadedFile.length; i++) {
      if (uploadedFile[i].id === state.uploadedDeleteImageId) {
        formData.append("file", uploadedFile[i].fileContent);
      }
    }
    formData.append("model", JSON.stringify(model));

    DocumentUpload(
      deleteURL,
      formData,
      true,
      true,
      authenticationState.accessToken,
      authenticationState.impersonateEmail
    )
      .then((response) => {
        if (response.Status === dataConstant.APIResponseStatus.Success) {
          showSnackbar(t("LeadCollection.BillDeleteSuccess"), "success");
          const updatedUploadBills = state.uploadBills.filter(
            (data) => data.id !== state.selectedDeletedImage
          );
          const updatedUploadedFiles = uploadedFile.filter(
            (file) => file.id !== state.selectedDeletedImage
          );
          setState((prevState) => ({
            ...prevState,
            uploadBills: updatedUploadBills,
            isDeletedPopupOpen: false,
            selectedDeletedImage: "",
          }));
          setUploadedFile(updatedUploadedFiles);
        }
      })
      .catch((err) => {
        console.error(err);
      });
    setState((prevState) => ({
      ...prevState,
      isUploadFileDeletePopupOpen: false,
      uploadedDeleteImageId: "",
    }));
  };

  const handleNoUploadedDeletePopupModal = () => {
    setState((prevState) => ({
      ...prevState,
      isUploadFileDeletePopupOpen: false,
      uploadedDeleteImageId: "",
    }));
  };

  const handleSubmitFreedom = async (data) => {
    const addressFields = ["streetAddress", "city", "state", "zipCode"];
    const allFieldsFilled = addressFields.every((field) => {
      const value = methods.getValues(field);
      return value !== undefined && value !== null && value !== "";
    });
    if (!allFieldsFilled) {
      setIsFinalSubmit(true);
      await methods.trigger(addressFields);
      showSnackbar(
        t("LeadCollection.homeownerPhysicalAddressRequired"),
        "warning"
      );
      return;
    }
    setIsFinalSubmit(true);
    setState((prevState) => ({
      ...prevState,
      finalSubmitCount: prevState.finalSubmitCount + 1,
      leadInfo: {
        ...prevState.leadInfo,
        submitToFreedomForever: true,
      },
      isFinalSubmitDisabled: true,
    }));
  };

  const handleOptionChange = (event) => {
    const selectedValue = event.target.value === "true";
    setState((prevState) => ({
      ...prevState,
      leadInfo: {
        ...prevState.leadInfo,
        isExistingSystem: selectedValue,
      },
    }));
  };

  const handleMentorAccept = () => {
    if (
      businessType === dataConstant.ReinH2O.label ||
      businessType === dataConstant.HomeService.label
    ) {
      handleYesAcceptMentorPopupModal();
    } else {
      setState((prevState) => ({
        ...prevState,
        isMentorAcceptPopupOpen: true,
      }));
    }
  };

  const handleMentorReject = () => {
    setState((prevState) => ({
      ...prevState,
      isMentorRejectPopupOpen: true,
    }));
  };

  const handleImageUploadError = (errorData) => {
    switch (errorData.type) {
      case "maxImages":
        showSnackbar(errorData.message, "warning");
        break;
      case "fileSize":
        showSnackbar(errorData.message, "warning");
        break;
      case "fileType":
        showSnackbar(errorData.message, "warning");
        break;
      case "fileValidation":
        showSnackbar(errorData.message, "warning");
        break;
      case "processing":
        showSnackbar(errorData.message, "warning");
        break;
      default:
        console.log(errorData.message);
    }
  };

  const handleYesAcceptMentorPopupModal = () => {
    let leadStatusValue = LeadStatusDefaultValue;
    leadStatusValue = _.find(leadStatusList, (i) => {
      return (
        i.value === dataConstant.LeadCollections.LeadStatus.ApprovedByMentor
      );
    });
    setState((prevState) => ({
      ...prevState,
      isMentorAcceptPopupOpen: false,
      leadInfo: {
        ...prevState.leadInfo,
        leadStatus: leadStatusValue,
      },
    }));
    handleSubmitFreedom();
  };

  const handleNoAcceptMentorPopupModal = () => {
    setState((prevState) => ({
      ...prevState,
      isMentorAcceptPopupOpen: false,
    }));
  };

  const handleYesRejectMentorPopupModal = async () => {
    isRejected = true;
    await handleSubmit1(state.leadInfo);
  };

  const handleNoRejectMentorPopupModal = () => {
    setState((prevState) => ({
      ...prevState,
      isMentorRejectPopupOpen: false,
    }));
  };

  const handleSubmitSearch = () => {
    setDescription("");
    setDescriptionOn(false);
    setShouldKeepMentorDropdownOpen(true);
    setState((prevValue) => ({
      ...prevValue,
      leadInfo: {
        ...prevValue.leadInfo,
        mentor: mentorDefaultValue,
        assignYouselfMentor: false,
      },
    }));
    setShowMentor(true);
    const finalselectedLanguage =
      languageIds && languageIds.length > 0
        ? languageIds.map((item) => item.value).join(",")
        : null;
    const finalselectedStates =
      stateIds && stateIds.length > 0
        ? stateIds.map((item) => item.value).join(",")
        : null;
    const searchParams = new URLSearchParams();
    if (searchText !== null) {
      searchParams.set("SearchText", searchText);
    }

    if (finalselectedLanguage !== null) {
      searchParams.set("LanguageIds", finalselectedLanguage);
    }

    if (finalselectedStates !== null) {
      searchParams.set("StateIds", finalselectedStates);
    }
    if (businessType != null) {
      searchParams.set("BusinessType", businessType);
    }
    if (businessType === dataConstant.HomeService.label && watchedHomeSecurityType?.value) {
      searchParams.set("HomeSecurityType", getHomeSecurityType(watchedHomeSecurityType?.value));
    }
    const getUserListURL = `${
      urlConstant.LeadCollections.LeadMentorSearchList
    }?${searchParams.toString()}`;
    httpGet(
      getUserListURL,
      true,
      true,
      authenticationState.accessToken,
      authenticationState.impersonateEmail
    )
      .then((response) => {
        if (response.Value.Data !== null) {
          mentorList = response.Value.Data;
          setDropdownData((prev) => ({
            ...prev,
            mentor: mentorList,
          }));

          if (mentorList.length === 1) {
            const singleMentor = mentorList[0];
            setShouldKeepMentorDropdownOpen(false);
            setValue("mentor", singleMentor, { shouldValidate: true });
            handleMentorChange(singleMentor);
          }

          setActiveStep(1);
        } else {
          setDropdownData((prev) => ({
            ...prev,
            mentor: [],
          }));
          if (businessType === dataConstant.HomeService.label && !methods.getValues("homeSecurityType")) {
            showSnackbar(t("LeadCollection.homeServiceTypeRequired"), "warning");
            return;
          }
          setActiveStep(1);
          showSnackbar(t("LeadCollection.Mentor not found"), "warning");
        }
      })
      .catch((error) => {
        console.error("Error fetching dropdown items:", error);
        setDropdownData((prev) => ({
          ...prev,
          mentor: mentorList,
        }));
      });
  };

  const handleAssignMentor = async (data) => {
    const personalInfoFields = [
      "firstName",
      "lastName",
      "emailAddress",
      "phoneNumber",
    ];
    const addressFields = ["streetAddress", "city", "state", "zipCode"];
    const homeServiceTypeFields = ["homeSecurityType"];

    const allPersonalInfoFilled = personalInfoFields.every((field) => {
      const value = methods.getValues(field);
      return value !== undefined && value !== null && value !== "";
    });
    const allFieldsFilled = addressFields.every((field) => {
      const value = methods.getValues(field);
      return value !== undefined && value !== null && value !== "";
    });
     const allHomeServiceTypeFields  = homeServiceTypeFields.every((field) => {
     const value = methods.getValues(field);
     return value !== undefined && value !== null && value !== "";
    });
    if (!allPersonalInfoFilled) {
      setIsFinalSubmit(true);
      await methods.trigger(personalInfoFields);
      requestAnimationFrame(() => scrollToFirstErrorSection(methods.formState.errors));
      return;
    }
    if (businessType === dataConstant.HomeService.label && !allHomeServiceTypeFields) {
      setIsFinalSubmit(true);
      await methods.trigger(allHomeServiceTypeFields);
      showSnackbar(
        t("LeadCollection.homeServiceTypeRequired"),
        "warning"
      );
      requestAnimationFrame(() => scrollToFirstErrorSection(methods.formState.errors));
      return;
    }
    if (!allFieldsFilled) {
      setIsFinalSubmit(true);
      await methods.trigger(addressFields);
      showSnackbar(
        t("LeadCollection.homeownerPhysicalAddressRequired"),
        "warning"
      );
      requestAnimationFrame(() => scrollToFirstErrorSection(methods.formState.errors));
      return;
    }
    setIsFinalSubmit(false);
    const mentor = state.leadInfo.mentor;
    const hasValidMentor = mentor && (mentor[0].value > 0 || mentor.AcctID > 0);
    if (!hasValidMentor) {
      setIsFinalSubmit(true);
      showSnackbar(t("LeadCollection.MentorSelection"), "warning");
      return;
    }

    isApprovalPenidng = true;
    setIsFinalSubmit(true);

    const approvalPendingStatus =
      _.find(
        leadStatusList,
        (status) =>
          status.value ===
          dataConstant.LeadCollections.LeadStatus.ApprovalPendingFromMentor
      ) || LeadStatusDefaultValue;

    setState((prev) => ({
      ...prev,
      submitToMentorCount: prev.submitToMentorCount + 1,
      leadInfo: {
        ...prev.leadInfo,
        submitToFreedomForever: false,
        leadStatus: approvalPendingStatus,
      },
      isSubmitDisabled: true,
    }));
  };

  const handleSubmit1 = async (data) => {
    setIsFinalSubmit(false);
    let leadStatusValue = LeadStatusDefaultValue;
    if (leadID === "" || leadID === null) {
      leadStatusValue = _.find(leadStatusList, (i) => {
        return i.value === dataConstant.LeadCollections.LeadStatus.New;
      });
    } else if (isRejected) {
      leadStatusValue = _.find(leadStatusList, (i) => {
        return (
          i.value === dataConstant.LeadCollections.LeadStatus.RejectedByMentor
        );
      });
    } else {
      leadStatusValue = _.find(leadStatusList, (i) => {
        return i.value === state.leadInfo.leadStatus.value;
      });
    }
    setState((prevState) => ({
      ...prevState,
      submitCount: prevState.submitCount + 1,
      leadInfo: {
        ...prevState.leadInfo,
        submitToFreedomForever: false,
        leadStatus: leadStatusValue,
      },
      isSubmitDisabled: true,
    }));
  };

  const onSubmit = (data) => {
    const isSolar = businessType === dataConstant.Solar.label;
    const home = businessType === dataConstant.HomeService.label;

    const hasFiles = state.uploadBills.length > 0 || uploadedFile.length > 0;

    let updatedData = {
      ...data,
      isExistingSystem: state.leadInfo.isExistingSystem,
      submitToFreedomForever: state.leadInfo.submitToFreedomForever,
      leadStatus: state.leadInfo.leadStatus,
    };
   
    if (home && (!data.homeSecurityType || !data.homeSecurityType.value)) {
    showSnackbar(t("LeadCollection.homeServiceTypeRequired"), "warning");
    return;
    }
    
    if (!leadID) {
      updatedData = { ...updatedData, leadStatus: "New" };
      if (isSolar && !hasFiles) {
        showSnackbar(t("LeadCollection.UtilityBillRequired"), "warning");
        return;
      }
      createLead(updatedData);
      return;
    }

    if (isSolar && !hasFiles) {
      showSnackbar(t("LeadCollection.UtilityBillRequired"), "warning");
      return;
    }

    editLead(updatedData);
  };

  const createLead = (event) => {
    let finalSelectedProductInterested = "";
    if (businessType === dataConstant.HomeService.label) {
      if (Array.isArray(event.productInterested)) {
        finalSelectedProductInterested = event.productInterested.length > 0 
          ? (event.productInterested[0]?.value || event.productInterested[0] || "")
          : "";
      } else {
        finalSelectedProductInterested = event.productInterested?.value || event.productInterested || "";
      }
    } else {
      finalSelectedProductInterested = _.map(event.productInterested, "value").join(",");
    }   
    
    let leadstatus = "";
    if (isApprovalPenidng) {
      leadstatus =
        dataConstant.LeadCollections.LeadStatus.ApprovalPendingFromMentor;
    } else if (isApproved) {
      leadstatus = dataConstant.LeadCollections.LeadStatus.ApprovedByMentor;
    } else {
      leadstatus = dataConstant.LeadCollections.LeadStatus.New;
    }
    const model = {
      FirstName: event.firstName,
      LastName: event.lastName,
      Phone: event.phoneNumber,
      ToDeleteImage: state.toDeleteImage,
      PublicEmail: event.emailAddress.toLowerCase(),
      StreetAddress: event.streetAddress,
      City: event.city,
      StateID: event?.state?.value ?? event?.state ?? null,
      ZipCode: event.zipCode,
      UtilityCompanyName: event.utilityCompanyName,
      AnnualConsumption: event.annualConsumption,
      RoofAge: event.roofAge ? event.roofAge.value : null,
      RoofType: event.roofType ? event.roofType.value : null,
      KindOfElectricPanel: event.kindOfElectricPanel
        ? event.kindOfElectricPanel.value
        : null,
      MountingPreference: event.mountingPreference
        ? event.mountingPreference.value
        : null,
      Work: event.work ? event.work.value : null,
      Financing: event.financing ? event.financing.value : null,
      IsExistingSystem: event.isExistingSystem,
      NotKnowHOA: event.notKnowHOA,
      HOAName: event.hoaName,
      HOAPhone: event.hoaPhone,
      HOAEmail: event.hoaEmail,
      SubmitToFreedomForever: state.leadInfo.submitToFreedomForever,
      Mentor: event.mentor ? event.mentor.value : null,
      LeadStatus: leadstatus,
      AdditionalInformation: event.additionalInfo,
      AssignYouselfMentor: event.assignYouselfMentor,
      AffiliateId: event.affiliate ? event.affiliate.value : null,
      AffiliateCommission:
        businessType === dataConstant.Solar.label
          ? event.affiliateCommission
            ? event.affiliateCommission.value
            : null
          : businessType === dataConstant.HomeService.label
          ? event.affiliateCommissionSecurity
          : event.affiliateCommissionRein,
      BusinessTypeID:
        businessType === dataConstant.ReinH2O.label
          ? dataConstant.ReinH2O.value
          : businessType === dataConstant.HomeService.label
          ? dataConstant.HomeService.value
          : dataConstant.Solar.value,
      ProductInterested: finalSelectedProductInterested,
      HomeSecurityType: businessType === dataConstant.HomeService.label &&
          event.homeSecurityType !== null
          ? event.homeSecurityType.value
          : null,
    };
    
    const createURL = urlConstant.LeadCollections.CraeteLeadCollection;
    const formData = new FormData();
    for (let i = 0; i < state.uploadBills.length; i++) {
      formData.append("file", state.uploadBills[i].file);
    }
    formData.append("model", JSON.stringify(model));
    DocumentUpload(
      createURL,
      formData,
      true,
      true,
      authenticationState.accessToken,
      authenticationState.impersonateEmail
    )
      .then((response) => {
        if (response.Status === dataConstant.APIResponseStatus.Success) {
          if (state.leadInfo.submitToFreedomForever === true) {
            let leadStatusValue = LeadStatusDefaultValue;
            leadStatusValue = _.find(leadStatusList, (i) => {
              return (
                i.value ===
                dataConstant.LeadCollections.LeadStatus.ApprovedByMentor
              );
            });
            setState((prevState) => ({
              ...prevState,
              leadInfo: {
                ...prevState.leadInfo,
                leadStatus: leadStatusValue,
              },
            }));
            setState((prevState) => ({
              ...prevState,
              isFinalSubmitPopupOpen:
                businessType === dataConstant.Solar.label ? true : false,
            }));
            showSnackbar(t("LeadCollection.LeadSaveSuccess"), "success");
            if (
              businessType === dataConstant.ReinH2O.label ||
              businessType === dataConstant.HomeService.label
            ) {
              setTimeout(() => {
                navigate("/projects");
              }, 1000);
            }
          } else {
            showSnackbar(t("LeadCollection.LeadSaveSuccess"), "success");
            setTimeout(() => {
              navigate("/projects");
            }, 1000);
          }
        } else if (response.Status === dataConstant.APIResponseStatus.Failure) {
          showSnackbar(response.error, "error");
          setTimeout(() => {
            navigate("/projects");
          }, 1000);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const editLead = async (event) => {
    let finalSelectedProductInterested = "";
    if (businessType === dataConstant.HomeService.label) {
      if (Array.isArray(event.productInterested)) {
        finalSelectedProductInterested = event.productInterested.length > 0 
          ? (event.productInterested[0]?.value || event.productInterested[0] || "")
          : "";
      } else {
        finalSelectedProductInterested = event.productInterested?.value || event.productInterested || "";
      }
    } else {
      finalSelectedProductInterested = _.map(event.productInterested, "value").join(",");
    }
    
    let leadstatus = "";
    if (isRejected) {
      leadstatus = dataConstant.LeadCollections.LeadStatus.RejectedByMentor;
    } else if (isApproved) {
      leadstatus = dataConstant.LeadCollections.LeadStatus.ApprovedByMentor;
    } else {
      leadstatus = event.leadStatus
        ? event.leadStatus.value
        : dataConstant.LeadCollections.LeadStatus.ApprovalPendingFromMentor;
    }
    const model = {
      LeadID: leadID,
      FirstName: event.firstName,
      LastName: event.lastName,
      Phone: event.phoneNumber,
      ToDeleteImage: state.toDeleteImage,
      PublicEmail: event.emailAddress.toLowerCase(),
      StreetAddress: event.streetAddress,
      City: event.city,
      StateID: event?.state?.value ?? event?.state ?? null,
      ZipCode: event.zipCode,
      UtilityCompanyName: event.utilityCompanyName,
      AnnualConsumption: event.annualConsumption,
      RoofAge: event.roofAge ? event.roofAge.value : null,
      RoofType: event.roofType ? event.roofType.value : null,
      KindOfElectricPanel: event.kindOfElectricPanel
        ? event.kindOfElectricPanel.value
        : null,
      MountingPreference: event.mountingPreference
        ? event.mountingPreference.value
        : null,
      Work: event.work ? event.work.value : null,
      Financing: event.financing ? event.financing.value : null,
      IsExistingSystem: event.isExistingSystem,
      NotKnowHOA: event.notKnowHOA,
      HOAName: event.hoaName,
      HOAPhone: event.hoaPhone,
      HoaEmail: event.hoaEmail,
      AssignYouselfMentor: state.leadInfo.assignYouselfMentor,
      Mentor: event.mentor ? event.mentor.value : null,
      SubmitToFreedomForever: event.submitToFreedomForever,
      LeadStatus: event.leadStatus ? event.leadStatus.value : leadstatus,
      AdditionalInformation: event.additionalInfo,
      AffiliateId: event.affiliate ? event.affiliate.value : null,
      AffiliateCommission:
        businessType === dataConstant.Solar.label
          ? event.affiliateCommission
            ? event.affiliateCommission.value
            : null
          : businessType === dataConstant.HomeService.label
          ? event.affiliateCommissionSecurity
          : event.affiliateCommissionRein,
      ProductInterested: finalSelectedProductInterested,
      HomeSecurityType: businessType === dataConstant.HomeService.label &&
        event.homeSecurityType !== null
        ? event.homeSecurityType.value
        : null,
      BusinessTypeID:
        businessType === dataConstant.ReinH2O.label
          ? dataConstant.ReinH2O.value
          : businessType === dataConstant.HomeService.label
          ? dataConstant.HomeService.value
          : dataConstant.Solar.value,
    };

    const editURL = urlConstant.LeadCollections.EditLeadCollection;
    const formData = new FormData();
    for (let i = 0; i < state.uploadBills.length; i++) {
      formData.append("file", state.uploadBills[i].file);
    }
    formData.append("model", JSON.stringify(model));

    DocumentUpload(
      editURL,
      formData,
      true,
      true,
      authenticationState.accessToken,
      authenticationState.impersonateEmail
    )
      .then((response) => {
        if (response.Status === dataConstant.APIResponseStatus.Success) {
          if (state.leadInfo.submitToFreedomForever === true) {
            let leadStatusValue = LeadStatusDefaultValue;
            leadStatusValue = _.find(leadStatusList, (i) => {
              return (
                i.value ===
                dataConstant.LeadCollections.LeadStatus.ApprovedByMentor
              );
            });
            setState((prevState) => ({
              ...prevState,
              leadInfo: {
                ...prevState.leadInfo,
                leadStatus: leadStatusValue,
              },
            }));
            setState((prevState) => ({
              ...prevState,
              isFinalSubmitPopupOpen:
                businessType === dataConstant.Solar.label ? true : false,
            }));
            showSnackbar(t("LeadCollection.LeadSaveSuccess"), "success");
            if (
              businessType === dataConstant.ReinH2O.label ||
              businessType === dataConstant.HomeService.label
            ) {
              setTimeout(() => {
                navigate(`/manageProjects/${leadID}`, {
                  state: {
                    IsMentor: isMentor,
                    businessType: businessType,
                  },
                });
                navigate(0);
              }, 1000);
            }
          } else {
            showSnackbar(t("LeadCollection.LeadSaveSuccess"), "success");
            setTimeout(() => {
              navigate("/projects");
            }, 1000);
          }
        } else if (response.Status === dataConstant.APIResponseStatus.Failure) {
          showSnackbar(response.error, "error");
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const handleNoFinalSubmitPopupModal = () => {
    navigate("/projects");
    setState((prevState) => ({
      ...prevState,
      isFinalSubmitPopupOpen: false,
    }));
  };

  const handleYesFinalSubmitPopupModal = () => {
    const link = dataConstant.LeadCollections.FreedomPortalLogin;
    window.open(link, "_blank");
    setState((prevState) => ({
      ...prevState,
      isFinalSubmitPopupOpen: false,
    }));
    navigate("/projects");
  };

  const OnCreditFormClick = () => {
    if (state.leadInfo.isCreditForm !== true) {
      const model = {
        LeadID: leadID,
        IsCreditForm: true,
      };

      const editURL = urlConstant.LeadCollections.EditLeadCollection;
      const formData = new FormData();
      formData.append("model", JSON.stringify(model));

      DocumentUpload(
        editURL,
        formData,
        true,
        true,
        authenticationState.accessToken,
        authenticationState.impersonateEmail
      )
        .then((response) => {
          if (response.Status === dataConstant.APIResponseStatus.Success) {
            showSnackbar(t("LeadCollection.LeadSaveSuccess"), "success");
            setTimeout(() => {
              navigate(`/manageProjects/${leadID}`, {
                IsMentor: isMentor,
                businessType: businessType,
              });
            }, 1000);
          } else if (
            response.Status === dataConstant.APIResponseStatus.Failure
          ) {
            showSnackbar(response.error, "success");
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }
  };

  const tabs = [
    ...(showMenteeTab && leadID
      ? [
          {
            label: t("LeadCollection.MenteeDetails.SectionTitle"),
            content: (
              <>
                <Stack
                  direction={"row"}
                  justifyContent={"space-between"}
                  mb={2}
                  alignItems={"flex-start"}
                  gap={1}
                  sx={{ display: { xs: "flex", sm: "none" } }}
                >
                  <Typography
                    color="secondary.light"
                    variant="h4"
                    fontWeight={600}
                  >
                    {t("LeadCollection.MenteeDetails.SectionTitle")}
                  </Typography>
                </Stack>
                <Grid container spacing={3} sx={{ flexGrow: 1, width: "100%" }}>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <CustomTextField
                      methods={methods}
                      properties={formConfig.menteeFirstName}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <Stack spacing={3}>
                      <CustomTextField
                        methods={methods}
                        properties={formConfig.menteeLastName}
                      />
                    </Stack>
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <CustomTextField
                      methods={methods}
                      properties={formConfig.menteeEmail}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <CustomTextField
                      methods={methods}
                      properties={formConfig.menteePhoneNumber}
                    />
                  </Grid>
                </Grid>
              </>
            ),
          },
        ]
      : []),
    {
      label:
        businessType === dataConstant.ReinH2O.label ||
        businessType === dataConstant.HomeService.label
          ? t("LeadCollection.ReinH2O.CustomerContactInfo")
          : t("LeadCollection.ContactInfo"),
      content: (
        <>
          <Grid container spacing={3} sx={{ flexGrow: 1, width: "100%" }}>
            <Grid size={{ xs: 12, sm: 12 }} display={businessType === dataConstant.ReinH2O.label || businessType === dataConstant.Solar.label ? "" : "none"}>
              <Card
                sx={(theme) => ({
                  p: {
                    xs: "20px",
                    sm: "25px 30px",
                  },
                  background: theme.palette.common.headerbg,
                  borderRadius: "20px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  width: "100%",
                  gap: 1,
                })}
              >
                <CustomMultipleImageUpload
                  label={
                    businessType === dataConstant.ReinH2O.label ||
                    businessType === dataConstant.HomeService.label ? (
                      t("LeadCollection.ReinH2O.UploadImages")
                    ) : (
                      <>
                        {t("LeadCollection.UploadLable")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </>
                    )
                  }
                  supportedFormats={["jpg", "jpeg", "png", "pdf"]}
                  isDeletable={isFormFieldDisable}
                  images={uploadedFile}
                  maxSize={dataConstant.LeadCollections.MAX_FILE_SIZE_MB}
                  maxImages={dataConstant.LeadCollections.MAX_LENGTH}
                  onImageChange={handleImageChange}
                  deleteImage={handleDeleteImage}
                  onError={handleImageUploadError}
                  showInternalErrors={false}
                  isDownloadable={!!leadID}
                />
              </Card>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <CustomTextField
                key={formConfig.firstName.name}
                methods={methods}
                properties={formConfig.firstName}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <CustomTextField
                key={formConfig.lastName.name}
                methods={methods}
                properties={formConfig.lastName}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <CustomTextField
                key={formConfig.emailAddress.name}
                methods={methods}
                properties={formConfig.emailAddress}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <CustomTextField
                key={formConfig.phoneNumber.name}
                methods={methods}
                properties={formConfig.phoneNumber}
              />
            </Grid>
          </Grid>
        </>
      ),
    },
    {
      label:
        businessType === dataConstant.ReinH2O.label ||
        businessType === dataConstant.HomeService.label
          ? t("LeadCollection.ReinH2O.CustomerPhysicalAddress")
          : t("LeadCollection.PhysicalAddressLable"),
      content: (
        <>
          <Grid container spacing={3} sx={{ flexGrow: 1, width: "100%" }}>
            <Grid size={{ xs: 12, sm: 6 }}>
              <CustomTextField
                key={formConfig.streetAddress.name}
                methods={methods}
                properties={formConfig.streetAddress}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <CustomTextField
                methods={methods}
                properties={formConfig.city}
                key={formConfig.city.name}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <CustomAutoCompleteDropdown
                methods={methods}
                properties={formConfig.state}
                key={formConfig.state.name}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <CustomTextField
                key={formConfig.zipCode.name}
                methods={methods}
                properties={formConfig.zipCode}
              />
            </Grid>
          </Grid>
        </>
      ),
    },
    ...(businessType === dataConstant.HomeService.label 
      ? [
          {
            label: t("LeadCollection.HomeServiceType"),
            content: (
              <>
                <Stack
                  direction={"row"}
                  justifyContent={"space-between"}
                  mb={2}
                  alignItems={"flex-start"}
                  gap={1}
                  sx={{ display: { xs: "flex", sm: "none" } }}
                >
                  <Typography
                    color="secondary.light"
                    variant="h4"
                    fontWeight={600}
                  >
                   {t("LeadCollection.HomeServiceType")}                      
                  </Typography>
                </Stack>
                <>
                  <Grid container spacing={3} sx={{ flexGrow: 1, width: "100%" }}>
                    <Grid position={'relative'} size={{ xs: 12, sm: 6 }}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: {xs: "flex-start", sm: "flex-end"},
                          alignItems: "flex-end",
                          position: {xs: "static", sm: "absolute"},
                          right: 0,
                          zIndex: 2,
                          top: 0,
                          mb: {xs: 1, sm: 0},
                        }}
                      >
                        {selectedHomeSecurityType &&
                          getHomeSecurityPackageInfo() && (
                            <Typography
                              component="a"
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                handleHomeSecurityPackagesOpen();
                              }}
                              sx={{
                                color: "var(--primary)",
                                textDecoration: "underline",
                                cursor: "pointer",
                                fontSize: "0.75rem",
                                "&:hover": {
                                  textDecoration: "none",
                                },
                              }}
                            >
                              {getHomeSecurityPackageInfo().linkText}
                            </Typography>
                          )}
                      </Box>
                      <CustomAutoCompleteDropdown
                        key={formConfig.homeSecurityType.name}
                        methods={methods}
                        properties={formConfig.homeSecurityType}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                      {!(watchedHomeSecurityType?.value === dataConstant.LeadCollections.Internet) && (
                        <CustomAutoCompleteDropdown
                          key={formConfig.productInterested.name}
                          methods={methods}
                          properties={formConfig.productInterested}
                        />
                      )}
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                      <CustomAutoCompleteDropdown
                        key={formConfig.leadStatus.name}
                        methods={methods}
                        properties={formConfig.leadStatus}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                      <CustomTextAreaField
                        key={formConfig.additionalInfo.name}
                        methods={methods}
                        properties={formConfig.additionalInfo}
                      />
                    </Grid>
                  </Grid>
                </>
              </>
            ),
          },
        ]
      : []),
    {
      label: t("LeadCollection.AssignMentor"),
      content: (
        <>
          <Stack
            direction={"row"}
            justifyContent={"space-between"}
            mb={2}
            alignItems={"flex-start"}
            gap={1}
            sx={{ display: { xs: "flex", sm: "none" } }}
          >
            <Typography color="secondary.light" variant="h4" fontWeight={600}>
              {t("LeadCollection.AssignMentor")}
            </Typography>
          </Stack>
          <Grid container spacing={2} sx={{ width: "100%" }}>
            <Grid
              size={{ xs: 12, sm: 6 }}
              sx={{
                borderRight: {
                  xs: "none",
                  sm: "1px solid var(--secondary-main)",
                },
                borderBottom: {
                  xs: "1px solid var(--secondary-main)",
                  sm: "none",
                },
                pr: {
                  xs: 0,
                  sm: "15px",
                },
                pb: {
                  xs: "15px",
                  sm: 0,
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  mb: 2,
                }}
              >
                <Box
                  sx={{
                    width: 40,
                    height: 50,
                    borderRadius: "20px",
                    backgroundColor:
                      activeStep >= 1
                        ? "success.main"
                        : activeStep >= 0
                        ? "primary.main"
                        : "action.disabled",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "var(--black)",
                    fontWeight: 600,
                    fontSize: "24px",
                  }}
                >
                  {activeStep >= 1 ? "1" : "1"}
                </Box>
                <Typography variant="body1" my={1} color="secondary.text">
                  {t("LeadCollection.Step")}
                </Typography>
                <Typography variant="h5" color="secondary.text">
                  {businessType === dataConstant.ReinH2O.label
                    ? t("LeadCollection.ReinH2O.ReinH2OLeftSideTitle")
                    : businessType === dataConstant.HomeService.label
                    ? t("LeadCollection.ReinH2O.HomeServicesLeftSideTitle")
                    : t("LeadCollection.LeftSideTitle")}
                </Typography>
              </Box>

              <Card
                sx={(theme) => ({
                  p: {
                    xs: "20px",
                    sm: "30px",
                  },
                  background: theme.palette.secondary.lightest,
                  border: "1px solid var(--headerbg)",
                  borderRadius: "10px",
                  mt: 3,
                })}
              >
                <Box>
                  <Typography
                    color="secondary.light"
                    fontWeight={600}
                    variant="body1"
                    display={"inline"}
                  >
                    {t("LeadCollection.NoteBold")}
                  </Typography>
                  <Typography
                    color="secondary.light"
                    display={"inline"}
                    variant="body1"
                  >
                    {t("LeadCollection.LeftSideNote1")}
                  </Typography>
                </Box>
                <Typography color="secondary.light" variant="body1">
                  {t("LeadCollection.LeftSideNote2")}
                </Typography>
              </Card>
              <Typography
                color="secondary.light"
                fontWeight={600}
                variant="body1"
                sx={{ my: "20px" }}
              >
                {t("LeadCollection.LeftSideNote3")}
              </Typography>
              <Stack gap={"20px"}>
                <CustomAutoCompleteDropdown
                  key={formConfig.searchableMentor.name}
                  methods={methods}
                  properties={formConfig.searchableMentor}
                />
                <CustomMultiSelectDropdown
                  key={formConfig.StateIds.name}
                  methods={methods}
                  properties={formConfig.StateIds}
                />
                <CustomMultiSelectDropdown
                  key={formConfig.LanguageIds.name}
                  methods={methods}
                  properties={formConfig.LanguageIds}
                />
              </Stack>
              <Stack
                width={"100%"}
                alignItems={"center"}
                justifyContent={"center"}
                gap={2}
                direction={"row"}
                sx={{ mt: 3 }}
              >
                <Button
                  variant="contained"
                  sx={{ px: 3, gap: 1 }}
                  color="primary"
                  type="button"
                  disabled={isFormFieldDisable}
                  onClick={handleSubmitSearch}
                >
                  {t("Search")}
                  <EastIcon />
                </Button>
              </Stack>
            </Grid>

            <Grid size={{ xs: 12, sm: 6 }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  mb: 2,
                }}
              >
                <Box
                  sx={{
                    width: 40,
                    height: 50,
                    borderRadius: "20px",
                    backgroundColor:
                      activeStep >= 1 ? "primary.main" : "secondary.main",
                    opacity: activeStep >= 1 ? "1" : ".5",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "var(--black)",
                    fontWeight: 600,
                    fontSize: "24px",
                  }}
                >
                  2
                </Box>
                <Typography
                  variant="body1"
                  my={1}
                  sx={{ opacity: activeStep >= 1 ? "1" : ".5" }}
                  color="secondary.text"
                >
                  {t("LeadCollection.Step")}
                </Typography>
                <Typography
                  variant="h5"
                  sx={{ opacity: activeStep >= 1 ? "1" : ".5" }}
                  color="secondary.text"
                >
                  {businessType === dataConstant.ReinH2O.label
                    ? t("LeadCollection.ReinH2O.ReinH2ORightSideTitle")
                    : businessType === dataConstant.HomeService.label
                    ? t("LeadCollection.ReinH2O.HomeServicesRightSideTitle")
                    : businessType === dataConstant.HomeService.label
                    ? t("LeadCollection.ReinH2O.HomeServicesRightSideTitle")
                    : t("LeadCollection.RightSideTitle")}
                </Typography>
              </Box>

              <Box
                sx={{
                  opacity: showMentor ? 1 : 0.5,
                  pointerEvents: showMentor ? "auto" : "none",
                  boxShadow: "none",
                  borderRadius: "20px",
                }}
              >
                <Card
                  sx={(theme) => ({
                    p: {
                      xs: "20px",
                      sm: "10px 20px",
                    },
                    background: theme.palette.secondary.lightest,
                    border: "1px solid var(--headerbg)",
                    borderRadius: "10px",
                    mt: 3,
                  })}
                >
                  <Box>
                    <Typography
                      color="secondary.light"
                      variant="body1"
                      sx={{ mb: 1 }}
                      fontWeight={600}
                      display={"inline"}
                    >
                      {t("LeadCollection.NoteBold")}
                    </Typography>
                    <Typography
                      color="secondary.light"
                      variant="body1"
                      sx={{ mb: 1 }}
                      display={"inline"}
                    >
                      {t("LeadCollection.RightSideNote1")}
                    </Typography>
                  </Box>
                  <Typography color="secondary.light" variant="body1">
                    {t("LeadCollection.RightSideNote2")}
                  </Typography>
                </Card>
                <Typography
                  variant="body1"
                  color="secondary.light"
                  sx={{ my: "20px" }}
                  fontWeight={600}
                >
                  {t("LeadCollection.RightSideNote3")}
                </Typography>
                <CustomAutoCompleteDropdown
                  key={formConfig.mentor.name}
                  methods={methods}
                  properties={formConfig.mentor}
                />
                {descriptionOn && (
                  <Stack mt={"10px"}>
                    <Typography
                      variant="body2"
                      color="secondary.text"
                      sx={{ fontWeight: 500, mb: "4px", fontSize: "0.75rem" }}
                    >
                      {t("LeadCollection.Description")}
                    </Typography>
                    <Box
                      sx={{
                        height: "300px",
                        overflowY: "auto",
                        wordWrap: "break-word",
                        p: 2,
                        border: "1px solid #ccc",
                        borderRadius: "12px",
                        mt: 0,
                        color: "var(--black) !important",
                        background: "var(--inputs) !important",
                      }}
                      dangerouslySetInnerHTML={{
                        __html: description,
                      }}
                    />
                  </Stack>
                )}
              </Box>
            </Grid>
          </Grid>
        </>
      ),
    },
    {
      label: t("LeadCollection.AssignAffiliate"),
      content: (
        <>
          <Stack
            direction={"row"}
            justifyContent={"space-between"}
            mb={2}
            alignItems={"flex-start"}
            gap={1}
            sx={{ display: { xs: "flex", sm: "none" } }}
          >
            <Typography color="secondary.light" variant="h4" fontWeight={600}>
              {t("LeadCollection.AssignAffiliate")}
            </Typography>
          </Stack>
          <Grid container spacing={3} sx={{ flexGrow: 1, width: "100%" }}>
            <Grid size={{ xs: 12, sm: 6 }}>
              <CustomAutoCompleteDropdown
                key={formConfig.affiliate.name}
                methods={methods}
                properties={formConfig.affiliate}
              />
            </Grid>
            {businessType === dataConstant.Solar.label && (
              <Grid size={{ xs: 12, sm: 6 }}>
                <CustomAutoCompleteDropdown
                  key={formConfig.affiliateCommission.name}
                  methods={methods}
                  properties={formConfig.affiliateCommission}
                />
              </Grid>
            )}
            {businessType === dataConstant.ReinH2O.label && (
              <Grid size={{ xs: 12, sm: 6 }}>
                <CustomTextField
                  key={formConfig.affiliateCommissionRein.name}
                  methods={methods}
                  properties={formConfig.affiliateCommissionRein}
                />
              </Grid>
            )}
            {businessType === dataConstant.HomeService.label && (
              <Grid size={{ xs: 12, sm: 6 }}>
                <CustomTextField
                  key={formConfig.affiliateCommissionSecurity.name}
                  methods={methods}
                  properties={formConfig.affiliateCommissionSecurity}
                />
              </Grid>
            )}
          </Grid>
        </>
      ),
    },
    ...(businessType === dataConstant.ReinH2O.label || businessType === dataConstant.Solar.label
      ? [
          {
            label:             
                businessType === dataConstant.ReinH2O.label
                ? t("LeadCollection.ReinH2O.ReinH2OSiteInfo")
                : t("LeadCollection.SiteInfo"),
            content: (
              <>
                <Stack
                  direction={"row"}
                  justifyContent={"space-between"}
                  mb={2}
                  alignItems={"flex-start"}
                  gap={1}
                  sx={{ display: { xs: "flex", sm: "none" } }}
                >
                  <Typography
                    color="secondary.light"
                    variant="h4"
                    fontWeight={600}
                  >
                    { businessType === dataConstant.ReinH2O.label
                      ? t("LeadCollection.ReinH2O.ReinH2OSiteInfo")
                      : t("LeadCollection.SiteInfo")}
                  </Typography>
                </Stack>
                <Grid container spacing={3} sx={{ flexGrow: 1, width: "100%" }}>
                  {businessType === dataConstant.Solar.label && (
                    <>
                      <Grid size={{ xs: 12, sm: 6 }}>
                        <CustomTextField
                          key={formConfig.annualConsumption.name}
                          methods={methods}
                          properties={formConfig.annualConsumption}
                        />
                      </Grid>
                      <Grid size={{ xs: 12, sm: 6 }}>
                        <CustomTextField
                          key={formConfig.utilityCompanyName.name}
                          methods={methods}
                          properties={formConfig.utilityCompanyName}
                        />
                      </Grid>
                      <Grid size={{ xs: 12, sm: 6 }}>
                        <CustomAutoCompleteDropdown
                          key={formConfig.roofAge.name}
                          methods={methods}
                          properties={formConfig.roofAge}
                        />
                      </Grid>
                      <Grid size={{ xs: 12, sm: 6 }}>
                        <CustomAutoCompleteDropdown
                          key={formConfig.roofType.name}
                          methods={methods}
                          properties={formConfig.roofType}
                        />
                      </Grid>
                      <Grid size={{ xs: 12, sm: 6 }}>
                        <CustomAutoCompleteDropdown
                          key={formConfig.kindOfElectricPanel.name}
                          methods={methods}
                          properties={formConfig.kindOfElectricPanel}
                        />
                      </Grid>
                      <Grid size={{ xs: 12, sm: 6 }}>
                        <Controller
                          name="isExistingSystem"
                          control={control}
                          render={({ field }) => {
                            return (
                              <FormControl component="fieldset">
                                <FormLabel
                                  component="legend"
                                  sx={{
                                    color: "var(--secondary-text)",
                                    fontWeight: "400",
                                  }}
                                >
                                  {t("LeadCollection.ExistingSystem")}
                                </FormLabel>
                                <RadioGroup
                                  className="cm-checkbox"
                                  row
                                  value={field.value ? "true" : "false"}
                                  onChange={(e) => {
                                    const val = e.target.value === "true";
                                    field.onChange(val);
                                    handleOptionChange(e);
                                  }}
                                >
                                  <FormControlLabel
                                    value="true"
                                    disabled={isFormFieldDisable}
                                    control={
                                      <Radio
                                        icon={<CheckBoxOutlineBlankIcon />}
                                        checkedIcon={<CheckBoxIcon />}
                                      />
                                    }
                                    label={t("LeadCollection.Yes")}
                                  />
                                  <FormControlLabel
                                    value="false"
                                    disabled={isFormFieldDisable}
                                    control={
                                      <Radio
                                        icon={<CheckBoxOutlineBlankIcon />}
                                        checkedIcon={<CheckBoxIcon />}
                                      />
                                    }
                                    label={t("LeadCollection.No")}
                                  />
                                </RadioGroup>
                              </FormControl>
                            );
                          }}
                        />
                      </Grid>
                      <Grid size={{ xs: 12, sm: 6 }}>
                        <CustomAutoCompleteDropdown
                          key={formConfig.mountingPreference.name}
                          methods={methods}
                          properties={formConfig.mountingPreference}
                        />
                      </Grid>
                      <Grid size={{ xs: 12, sm: 3 }}>
                        <Controller
                          name="notKnowHOA"
                          control={control}
                          defaultValue={false}
                          render={({ field }) => (
                            <FormControl
                              component="fieldset"
                              className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 cm-HOA-Information cm-checkbox"
                            >
                              <FormLabel
                                component="legend"
                                sx={{
                                  color: "var(--secondary-text)",
                                  fontWeight: "400",
                                }}
                              >
                                {t("LeadCollection.HOAInfo")}
                              </FormLabel>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    {...field}
                                    checked={!!field.value}
                                    onChange={(e) =>
                                      field.onChange(e.target.checked)
                                    }
                                  />
                                }
                                disabled={isFormFieldDisable}
                                label={t("LeadCollection.CheckBox")}
                              />
                            </FormControl>
                          )}
                        />
                      </Grid>
                      {!isHOAHide && (
                        <>
                          <Grid size={{ xs: 12, sm: 6 }}>
                            <CustomTextField
                              key={formConfig.hoaName.name}
                              methods={methods}
                              properties={formConfig.hoaName}
                            />
                          </Grid>
                          <Grid size={{ xs: 12, sm: 6 }}>
                            <CustomTextField
                              key={formConfig.hoaEmail.name}
                              methods={methods}
                              properties={formConfig.hoaEmail}
                            />
                          </Grid>
                          <Grid size={{ xs: 12, sm: 6 }}>
                            <CustomTextField
                              key={formConfig.hoaPhone.name}
                              methods={methods}
                              properties={formConfig.hoaPhone}
                            />
                          </Grid>
                        </>
                      )}
                      <Grid size={{ xs: 12, sm: 6 }}>
                        <CustomAutoCompleteDropdown
                          key={formConfig.financing.name}
                          methods={methods}
                          properties={formConfig.financing}
                        />
                      </Grid>
                      <Grid size={{ xs: 12, sm: 6 }}>
                        <CustomAutoCompleteDropdown
                          key={formConfig.work.name}
                          methods={methods}
                          properties={formConfig.work}
                        />
                      </Grid>
                      <Grid size={{ xs: 12, sm: 6 }}>
                        <CustomAutoCompleteDropdown
                          key={formConfig.leadStatus.name}
                          methods={methods}
                          properties={formConfig.leadStatus}
                        />
                      </Grid>
                      <Grid size={{ xs: 12, sm: 6 }}>
                        <CustomTextAreaField
                          key={formConfig.additionalInfo.name}
                          methods={methods}
                          properties={formConfig.additionalInfo}
                        />
                      </Grid>
                    </>
                  )}
                 {businessType === dataConstant.ReinH2O.label && (
                    <>
                      <Grid size={{ xs: 12, sm: 6 }}>
                        <CustomMultiSelectDropdown
                          key={formConfig.productInterested.name}
                          methods={methods}
                          properties={formConfig.productInterested}
                        />
                      </Grid>
                      {businessType === dataConstant.ReinH2O.label && (
                        <Grid size={{ xs: 12, sm: 6 }}>
                          <CustomAutoCompleteDropdown
                            key={formConfig.financing.name}
                            methods={methods}
                            properties={formConfig.financing}
                          />
                        </Grid>
                      )}
                      <Grid size={{ xs: 12, sm: 6 }}>
                        <CustomAutoCompleteDropdown
                          key={formConfig.leadStatus.name}
                          methods={methods}
                          properties={formConfig.leadStatus}
                        />
                      </Grid>
                      <Grid size={{ xs: 12, sm: 6 }}>
                        <CustomTextAreaField
                          key={formConfig.additionalInfo.name}
                          methods={methods}
                          properties={formConfig.additionalInfo}
                        />
                      </Grid>
                    </>
                  )}
                </Grid>
              </>
            ),
          },
        ]
      : []),
  ];

  return (
    <>
      <Box flexDirection={"column"} gap={2} display={"flex"}>
        <Typography
          color="secondary.light"
          display={{ xs: "flex", sm: "none" }}
          variant="h4"
          fontSize={"24px"}
          fontWeight={600}
        >
          {t("LeadCollection.Leads")}
        </Typography>
        <Box width={"100%"}>
          <Card
            sx={(theme) => ({
              p: {
                xs: "20px",
                sm: "25px 30px",
              },
              background: theme.palette.background.cardGradient,
              border: "1px solid var(--headerbg)",
              borderRadius: "20px",
              height: "100%",
            })}
          >
            <Stack gap={"20px"}>
              <Typography color="secondary.light" variant="h4" fontWeight={600}>
                {t(state.formTitle)}
              </Typography>
              {state.isDisplay ? (
                <>
                  <form onSubmit={methods.handleSubmit(onSubmit, (errors) => scrollToFirstErrorSection(errors))}>
                    <Stack className="cm-leads-single-page" gap={3}>
                      {tabs.map((tab, index) => (
                        <div
                        key={index}
                        ref={(el) => (sectionRefs.current[index] = el)}
                      >
                        <Card
                          sx={(theme) => ({
                            p: "0",
                            background: theme.palette.common.black,
                            borderRadius: "20px",
                            width: "100%",
                            overflow: "hidden",
                          })}
                        >
                          <Stack>
                            <Box
                              ref={(el) => (sectionHeaderRefs.current[index] = el)}
                              onClick={() => toggleSection(index)}
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                p: "25px 30px",
                                cursor: "pointer",
                                backgroundColor: "rgba(0,0,0,0.2)",
                                "&:hover": {
                                  backgroundColor: "rgba(0,0,0,0.3)",
                                },
                                transition: "background-color 0.3s ease",
                              }}
                            >
                              <Typography
                                color="secondary.light"
                                variant="h5"
                                fontWeight={600}
                              >
                                {tab.label}
                              </Typography>
                              <IconButton
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                }}
                                sx={{
                                  color: "secondary.light",
                                }}
                              >
                                {isSectionExpanded(index) ? (
                                  <ExpandLessIcon />
                                ) : (
                                  <ExpandMoreIcon />
                                )}
                              </IconButton>
                            </Box>
                            <Stack
                              gap={2}
                              sx={{
                                p: "25px 30px",
                                display: isSectionExpanded(index)
                                  ? "flex"
                                  : "none",
                                flexDirection: "column",
                              }}
                            >
                              {tab.content}
                            </Stack>
                          </Stack>
                        </Card>
                      </div>
                      ))}
                      <Stack
                        width={"100%"}
                        alignItems={"center"}
                        justifyContent={"space-between"}
                        mt={2}
                        gap={"10px"}
                        direction={{ xs: "column-reverse", sm: "row" }}
                      >
                        <Stack
                          direction={{ xs: "column", sm: "row" }}
                          gap={"10px"}
                          width={{ xs: "100%", sm: "auto" }}
                        >
                          <Button
                            sx={{ px: 3, width: { xs: "100%", sm: "auto" } }}
                            variant="contained"
                            color="secondary"
                            onClick={() => navigate(-1)}
                          >
                            {t("LeadCollection.Cancel")}
                          </Button>
                          <Button
                            sx={{ px: 3, width: { xs: "100%", sm: "auto" } }}
                            variant="contained"
                            type="button"
                            color="secondary"
                            onClick={() => handleSubmit1()}
                            disabled={
                              isMentor &&
                              state.leadInfo.leadStatus.label ===
                                dataConstant.LeadCollections.LeadStatus
                                  .RejectedByMentor
                            }
                          >
                            {t("LeadCollection.SaveForLater")}
                          </Button>
                        </Stack>
                        <Stack
                          direction={"row"}
                          flexWrap={"wrap"}
                          width={{ xs: "100%", sm: "auto" }}
                          gap={"10px"}
                        >
                          {!mentorFlag && !selfMentorFlag && (
                            <Button
                              sx={{ px: 3, width: { xs: "100%", sm: "auto" } }}
                              variant="contained"
                              disabled={isFormFieldDisable}
                              onClick={() => handleAssignMentor()}
                            >
                              {t("LeadCollection.AssignToMentor")}
                            </Button>
                          )}
                          {leadID > 0 && mentorFlag && !selfMentorFlag && (
                            <>
                              <>
                                <Button
                                  variant="contained"
                                  color="primary"
                                  sx={{
                                    px: 3,
                                    width: { xs: "100%", sm: "auto" },
                                  }}
                                  type="button"
                                  disabled={
                                    isMentorButtonDisable ||
                                    (isMentor &&
                                      state.leadInfo.leadStatus.label ===
                                        dataConstant.LeadCollections.LeadStatus
                                          .RejectedByMentor)
                                  }
                                  onClick={() =>
                                    handleMentorAccept(state.leadInfo)
                                  }
                                >
                                  {t("LeadCollection.Approve")}
                                </Button>

                                {!selfMentorFlag && (
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    sx={{
                                      px: 3,
                                      width: { xs: "100%", sm: "auto" },
                                    }}
                                    type="button"
                                    disabled={
                                      isMentorButtonDisable ||
                                      selfMentorFlag ||
                                      (isMentor &&
                                        state.leadInfo.leadStatus.label ===
                                          dataConstant.LeadCollections
                                            .LeadStatus.RejectedByMentor)
                                    }
                                    onClick={() =>
                                      handleMentorReject(state.leadInfo)
                                    }
                                  >
                                    {t("LeadCollection.Reject")}
                                  </Button>
                                )}
                              </>
                            </>
                          )}
                          {selfMentorFlag && (
                            <>
                              <Button
                                variant="contained"
                                color="primary"
                                sx={{
                                  px: 3,
                                  width: { xs: "100%", sm: "auto" },
                                }}
                                type="button"
                                disabled={isFormFieldDisable}
                                onClick={() => handleSubmitFreedom()}
                              >
                                {t("LeadCollection.Approve")}
                              </Button>
                            </>
                          )}
                          {mentorFlag && (businessType === dataConstant.ReinH2O.label)
                            && state.leadInfo.leadStatus.label === dataConstant.LeadCollections.LeadStatus.ApprovedByMentor && (
                              <Stack
                                direction={{ xs: "column", sm: "row" }}
                                width={{ xs: "100%", sm: "auto" }}
                                gap={"10px"}
                              >
                                <a
                                  href={
                                    urlConstant.LeadCollections.CrediFormLink
                                  }
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    sx={{
                                      px: 3,
                                      width: { xs: "100%", sm: "auto" },
                                    }}
                                    type="button"
                                    onClick={OnCreditFormClick}
                                  >
                                    {t("LeadCollection.CreditForm")}
                                  </Button>
                                </a>

                                <a
                                  href={urlConstant.LeadCollections.ShopResidentialLink}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    sx={{
                                      px: 3,
                                      width: { xs: "100%", sm: "auto" },
                                    }}
                                    type="button"
                                  >
                                    {t("LeadCollection.ShopResidential")}
                                  </Button>
                                </a>
                              </Stack>
                          )}
                        </Stack>
                      </Stack>
                    </Stack>
                  </form>
                </>
              ) : null}
            </Stack>
          </Card>
        </Box>
      </Box>
      {state.isDeletedPopupOpen && (
        <Dialog
          onClose={handleNoDeletePopupModal}
          aria-labelledby="customized-dialog-title"
          open={state.isDeletedPopupOpen}
          sx={{ borderRadius: "20px", background: "transparent" }}
        >
          <Stack
            sx={(theme) => ({
              background: theme.palette.common.black,
              borderTopLeftRadius: "20px",
              borderTopRightRadius: "20px",
            })}
          >
            <DialogTitle id="delete-confirm-dialog-title">
              {t("LeadCollection.UploadedBillsLable")}
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={handleNoDeletePopupModal}
              sx={(theme) => ({
                position: "absolute",
                right: 8,
                top: 8,
                color: theme.palette.grey[500],
                p: 1,
                borderRadius: "8px",
              })}
            >
              <CloseIcon />
            </IconButton>
          </Stack>
          <DialogContent
            sx={(theme) => ({
              background: theme.palette.background.cardGradient,
              border: 0,
              borderBottomLeftRadius: "20px",
              borderBottomRightRadius: "20px",
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              alignItems: "center",
            })}
            dividers
          >
            <Stack textAlign={"center"}>
              <Typography
                color="secondary.light"
                sx={{}}
                variant="h4"
                fontWeight={600}
              >
                <Typography>{t("LeadCollection.DeletePopupText")}</Typography>
              </Typography>
            </Stack>
            <DialogActions>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                sx={{ px: 3 }}
                onClick={handleYesDeletePopupModal}
              >
                {t("LeadCollection.Yes")}
              </Button>
            </DialogActions>
          </DialogContent>
        </Dialog>
      )}
      {state.isUploadFileDeletePopupOpen && (
        <Dialog
          onClose={handleNoUploadedDeletePopupModal}
          aria-labelledby="customized-dialog-title"
          open={state.isUploadFileDeletePopupOpen}
          sx={{ borderRadius: "20px", background: "transparent" }}
        >
          <Stack
            sx={(theme) => ({
              background: theme.palette.common.black,
              borderTopLeftRadius: "20px",
              borderTopRightRadius: "20px",
            })}
          >
            <DialogTitle id="delete-confirm-dialog-title">
              {t("LeadCollection.DeletePopupTitle")}
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={handleNoUploadedDeletePopupModal}
              sx={(theme) => ({
                position: "absolute",
                right: 8,
                top: 8,
                color: theme.palette.grey[500],
                p: 1,
                borderRadius: "8px",
              })}
            >
              <CloseIcon />
            </IconButton>
          </Stack>
          <DialogContent
            sx={(theme) => ({
              background: theme.palette.background.cardGradient,
              border: 0,
              borderBottomLeftRadius: "20px",
              borderBottomRightRadius: "20px",
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              alignItems: "center",
            })}
            dividers
          >
            <Stack textAlign={"center"}>
              <Typography
                color="common.light"
                sx={{}}
                variant="h4"
                fontWeight={600}
              >
                <Typography>{t("LeadCollection.DeletePopupText")}</Typography>
              </Typography>
            </Stack>
            <DialogActions>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                onClick={handleYesUploadedDeletePopupModal}
              >
                {t("LeadCollection.Yes")}
              </Button>
            </DialogActions>
          </DialogContent>
        </Dialog>
      )}
      {state.isMentorAcceptPopupOpen && (
        <Dialog
          open={state.isMentorAcceptPopupOpen}
          onClose={handleNoAcceptMentorPopupModal}
          sx={{ borderRadius: "20px", background: "transparent" }}
          aria-labelledby="customized-dialog-title"
        >
          <Stack
            sx={(theme) => ({
              background: theme.palette.common.black,
              borderTopLeftRadius: "20px",
              borderTopRightRadius: "20px",
            })}
          >
            <DialogTitle sx={{ fontWeight: "bold", px: 2 }}>
              {t("LeadCollection.SubmitLeadPopupTitle")}
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={handleNoAcceptMentorPopupModal}
              sx={(theme) => ({
                position: "absolute",
                right: 8,
                top: 8,
                color: theme.palette.grey[500],
                p: 1,
                borderRadius: "8px",
              })}
            >
              <CloseIcon />
            </IconButton>
          </Stack>
          <DialogContent
            sx={(theme) => ({
              background: theme.palette.background.cardGradient,
              border: 0,
              borderBottomLeftRadius: "20px",
              borderBottomRightRadius: "20px",
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              alignItems: "center",
            })}
            dividers
          >
            <Stack textAlign={"center"}>
              <Typography
                color="common.light"
                sx={{}}
                variant="h4"
                fontWeight={600}
              >
                <Typography variant="body1" sx={{ textAlign: "left" }}>
                  {t("LeadCollection.SubmitLeadPopupText").replace(
                    "{0}",
                    `${state.leadInfo.firstName} ${state.leadInfo.lastName}`
                  )}
                </Typography>
              </Typography>
            </Stack>
            <Stack
              sx={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                flexWrap: { xs: "wrap", sm: "nowrap" },
                gap: 1,
                px: 2,
                pb: 2,
              }}
            >
              <Button
                variant="contained"
                color="secondary"
                sx={{ px: 3, width: { xs: "100%", sm: "auto" } }}
                onClick={handleNoAcceptMentorPopupModal}
              >
                {t("LeadCollection.Cancel")}
              </Button>
              <Button
                variant="contained"
                color="primary"
                sx={{ px: 3, width: { xs: "100%", sm: "auto" } }}
                onClick={handleYesAcceptMentorPopupModal}
              >
                {t("LeadCollection.ApprovePopupBtnText")}
              </Button>
            </Stack>
          </DialogContent>
        </Dialog>
      )}
      {state.isMentorRejectPopupOpen && (
        <Dialog
          open={state.isMentorRejectPopupOpen}
          onClose={handleNoRejectMentorPopupModal}
          sx={{ borderRadius: "20px", background: "transparent" }}
        >
          <Stack
            sx={(theme) => ({
              background: theme.palette.common.black,
              borderTopLeftRadius: "20px",
              borderTopRightRadius: "20px",
              flexDirection: 'row',
              width: '100%',
              alignItems: 'center',
              justifyContent: 'space-between',
              pr: '10px',
            })}
          >
            <DialogTitle sx={{ fontWeight: "bold", px: 2, flex: 'auto'}}>
              {t("LeadCollection.RejectLeadPopupTitle")}
            </DialogTitle>
            <IconButton
              className="close-icon-bg"
              aria-label="close"
              onClick={handleNoRejectMentorPopupModal}
              sx={(theme) => ({
                position: "static",
                right: 8,
                top: 8,
                color: theme.palette.grey[500],
                p: 1,
                borderRadius: "8px",
              })}
            >
              <CloseIcon />
            </IconButton>
          </Stack>
          <DialogContent
            sx={(theme) => ({
              background: theme.palette.background.cardGradient,
              border: 0,
              borderBottomLeftRadius: "20px",
              borderBottomRightRadius: "20px",
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              alignItems: "center",
            })}
            dividers
          >
            <Stack textAlign={"center"}>
              <Typography
                color="common.light"
                sx={{}}
                variant="h4"
                fontWeight={600}
              >
                <Typography variant="body1" sx={{ textAlign: "left" }}>
                  {t("LeadCollection.RejectLeadPopupText").replace(
                    "{0}",
                    `${state.leadInfo.firstName} ${state.leadInfo.lastName}`
                  )}
                </Typography>{" "}
              </Typography>
            </Stack>
            <Stack
              sx={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                flexWrap: { xs: "wrap", sm: "nowrap" },
                gap: 1,
                px: 2,
                pb: 2,
              }}
            >
              <Button
                variant="contained"
                color="secondary"
                fullWidth
                sx={{ px: 3, width: { xs: "100%", sm: "auto" } }}
                onClick={handleNoRejectMentorPopupModal}
              >
                {t("LeadCollection.Cancel")}
              </Button>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                sx={{ px: 3, width: { xs: "100%", sm: "auto" } }}
                onClick={handleYesRejectMentorPopupModal}
              >
                {t("LeadCollection.FinalRejectPopupText")}
              </Button>
            </Stack>
          </DialogContent>
        </Dialog>
      )}
      {state.isFinalSubmitPopupOpen && (
        <Dialog
          open={state.isFinalSubmitPopupOpen}
          onClose={handleNoFinalSubmitPopupModal}
          sx={{ borderRadius: "20px", background: "transparent" }}
        >
          <Stack
            sx={(theme) => ({
              background: theme.palette.common.black,
              borderTopLeftRadius: "20px",
              borderTopRightRadius: "20px",
            })}
          >
            <DialogTitle sx={{ fontWeight: "bold", px: 2 }}>
              {t("LeadCollection.FinalSubmitPopupTitle")}
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={handleNoFinalSubmitPopupModal}
              sx={(theme) => ({
                position: "absolute",
                right: 8,
                top: 8,
                color: theme.palette.grey[500],
                p: 1,
                borderRadius: "8px",
              })}
            >
              <CloseIcon />
            </IconButton>
          </Stack>
          <DialogContent
            sx={(theme) => ({
              background: theme.palette.background.cardGradient,
              border: 0,
              borderBottomLeftRadius: "20px",
              borderBottomRightRadius: "20px",
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              alignItems: "center",
            })}
            dividers
          >
            <Stack
              sx={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                flexWrap: { xs: "wrap", sm: "nowrap" },
                gap: 1,
                px: 2,
                pb: 2,
              }}
            >
              <Button
                variant="contained"
                color="secondary"
                sx={{ px: 3, width: { xs: "100%", sm: "auto" } }}
                onClick={handleNoFinalSubmitPopupModal}
              >
                {t("LeadCollection.Cancel")}
              </Button>
              <Button
                variant="contained"
                color="primary"
                sx={{ px: 3, width: { xs: "100%", sm: "auto" } }}
                onClick={handleYesFinalSubmitPopupModal}
              >
                {t("LeadCollection.FinalSubmitPopupText")}
              </Button>
            </Stack>
          </DialogContent>
        </Dialog>
      )}

      {/* Add Lead Popup - Choose Business Type */}
      <Dialog
        open={state.isAddLeadPopupOpen}
        onClose={(event, reason) => {
          if (reason === "backdropClick" && reason === "escapeKeyDown") {
            return;
          }
        }}
        aria-labelledby="customized-dialog-title"
        sx={{ borderRadius: "20px", background: "transparent" }}
      >
        <Stack
          sx={(theme) => ({
            background: theme.palette.common.black,
            borderTopLeftRadius: "20px",
            borderTopRightRadius: "20px",
          })}
        >
          <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
            {t("LeadCollection.AddLead")}
          </DialogTitle>
        </Stack>
        <DialogContent
          sx={(theme) => ({
            background: theme.palette.background.cardGradient,
            border: 0,
            borderBottomLeftRadius: "20px",
            borderBottomRightRadius: "20px",
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            alignItems: "center",
          })}
          dividers
        >
          <Button
            variant="contained"
            sx={{ px: 0.8, py: 0.5, width: "auto", backgroundColor: "#FF6C6C" }}
            color="primary"
            disableElevation
          >
            <img src="/icons/user-header.svg" alt="user" />
          </Button>
          <Stack direction={"column"} alignItems={"center"}>
            <Typography color="secondary.light" variant="body1">
              {t("LeadCollection.LeadFor")}
            </Typography>
          </Stack>
          <Stack
            direction={{ xs: "column", sm: "row" }}
            flexWrap={"wrap"}
            gap={2}
            width={"100%"}
            justifyContent={"center"}
            borderTop={"1px solid var(--headerbg)"}
            paddingTop={"20px"}
          >
            {state.projectList
              .filter((item) => !item.isDisabled)
              .map((item, index) => {
                return (
                  <Button
                    variant="contained"
                    sx={{ px: 3, width: { xs: "100%", sm: "auto" } }}
                    key={index}
                    onClick={() => {
                      setBusinessType(item.label);
                      setState((prevState) => ({
                        ...prevState,
                        isAddLeadPopupOpen: false,
                        formTitle: `${t("LeadCollection.AddLead")}  - ${
                          item.label
                        }`,
                      }));
                    }}
                  >
                    {item.label}
                  </Button>
                );
              })}
          </Stack>
        </DialogContent>
      </Dialog>
      <CommonSnackBar snackObj={snack} closeSnack={closeSnack} buttonProp />

      {/* Home Service Packages Popup */}
      {state.isHomeSecurityPackagesPopupOpen && getHomeSecurityPackageInfo() && (
        <Dialog
          open={state.isHomeSecurityPackagesPopupOpen}
          onClose={handleHomeSecurityPackagesClose}
          maxWidth="md"
          fullWidth
          sx={{ 
            borderRadius: "20px", 
            background: "transparent",
            '& .MuiDialog-paper': {
              '&::-webkit-scrollbar': {
                display: 'none'
              },
              '-ms-overflow-style': 'none',
              'scrollbar-width': 'none'
            }
          }}
        >
          <Stack
            sx={(theme) => ({
              background: theme.palette.common.black,
              borderTopLeftRadius: "20px",
              borderTopRightRadius: "20px",
            })}
          >
            <DialogTitle sx={{ m: 0, p: 2, fontWeight: "bold" }}>
              {getHomeSecurityPackageInfo().title}
              <IconButton
                aria-label="download"
                onClick={handleHomeSecurityTypePackageImgDownload}
                sx={(theme) => ({
                  color: "var(--primary-main)",
                  p: 1,
                  borderRadius: "8px",
                })}
              >
                <DownloadForOfflineIcon />
              </IconButton>
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={handleHomeSecurityPackagesClose}
              sx={(theme) => ({
                position: "absolute",
                right: 8,
                top: 8,
                color: theme.palette.grey[500],
                p: 1,
                borderRadius: "8px",
              })}
            >
              <CloseIcon />
            </IconButton>
          </Stack>
          <DialogContent
            sx={(theme) => ({
              background: theme.palette.background.cardGradient,
              border: 0,
              borderBottomLeftRadius: "20px",
              borderBottomRightRadius: "20px",
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              alignItems: "center",
              p: 3,
              '&::-webkit-scrollbar': {
                display: 'none'
              },
              '-ms-overflow-style': 'none',
              'scrollbar-width': 'none',
              overflow: 'auto'
            })}
          >
            <Box
              component="img"
              src={getHomeSecurityPackageInfo().imageUrl}
              alt={getHomeSecurityPackageInfo().title}
              sx={{
                maxWidth: "100%",
                height: "auto",
                borderRadius: "10px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              }}
            />
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};
export default ManageProjects;